import React from "react";
import { numberToCurrency, numberWithCommas } from "./Utils";
import { FULL_COUNTRY } from "./fullCountry";

export const DISTRICTS = [
  {
    text: "강원도",
    value: "강원도",
  },
  {
    text: "경기도",
    value: "경기도",
  },
  {
    text: "경상남도",
    value: "경상남도",
  },
  {
    text: "경상북도",
    value: "경상북도",
  },
  {
    text: "광주광역시",
    value: "광주광역시",
  },
  {
    text: "대구광역시",
    value: "대구광역시",
  },
  {
    text: "대전광역시",
    value: "대전광역시",
  },
  {
    text: "부산광역시",
    value: "부산광역시",
  },
  {
    text: "서울특별시",
    value: "서울특별시",
  },
  {
    text: "세종특별자치시",
    value: "세종특별자치시",
  },
  {
    text: "울산광역시",
    value: "울산광역시",
  },
  {
    text: "인천광역시",
    value: "인천광역시",
  },
  {
    text: "전라남도",
    value: "전라남도",
  },
  {
    text: "전라북도",
    value: "전라북도",
  },
  {
    text: "제주특별자치도",
    value: "제주특별자치도",
  },
  {
    text: "충청남도",
    value: "충청남도",
  },
  {
    text: "충청북도",
    value: "충청북도",
  },
];

export const INDUSTRY_TYPE = [
  {
    text: "외식업 - 음식점업",
    value: "food-food",
  },
  {
    text: "외식업 - 디저트",
    value: "food-dessert",
  },
  {
    text: "외식업 - 주점 및 비알코올 음료점업",
    value: "food-drink",
  },
  {
    text: "소매업 - 종합소매업",
    value: "retail-total",
  },
  {
    text: "소매업 - 음, 식료품",
    value: "retail-foodRetail",
  },
  {
    text: "소매업 - 면세점",
    value: "retail-duty",
  },
  {
    text: "소매업 - 패션의류/잡화",
    value: "retail-fashion",
  },
  {
    text: "소매업 - 뷰티용품 판매점",
    value: "retail-beauty",
  },
  {
    text: "소매업 - 출산/유아동",
    value: "retail-babyProducts",
  },
  {
    text: "소매업 - 생활/주방용품",
    value: "retail-lifeProducts",
  },
  {
    text: "소매업 - 가구/인테리어",
    value: "retail-furniture",
  },
  {
    text: "소매업 - 가전 디지털 판매점",
    value: "retail-digitalProducts",
  },
  {
    text: "소매업 - 스포츠/레저용품 판매점",
    value: "retail-sports",
  },
  {
    text: "소매업 - 자동차 용품 판매점",
    value: "retail-vehicle",
  },
  {
    text: "소매업 - 취미/문구/악기",
    value: "retail-hobby",
  },
  {
    text: "소매업 - 도서 판매",
    value: "retail-book",
  },
  {
    text: "소매업 - 반려동물용품",
    value: "retail-animalProducts",
  },
  {
    text: "소매업 - 건강/의료용품",
    value: "retail-medical",
  },
  {
    text: "소매업 - 그외 기타 소매업",
    value: "retail-extraRetail",
  },
  {
    text: "서비스업 - 교육서비스업",
    value: "service-education",
  },
  {
    text: "서비스업 - 부동산업",
    value: "service-realEstate",
  },
  {
    text: "서비스업 - 스포츠 및 오락관련 서비스업",
    value: "service-sports",
  },
  {
    text: "서비스업 - 사진 촬영 및 스튜디오",
    value: "service-photography",
  },
  {
    text: "서비스업 - 숙박업",
    value: "service-accomodation",
  },
  {
    text: "서비스업 - 보건업",
    value: "service-health",
  },
  {
    text: "서비스업 - 미용업",
    value: "service-beauty",
  },
  {
    text: "소매업 - 그 외 기타 서비스업",
    value: "service-extra",
  },
];

export const ORDER_ORIGIN = [
  {
    label: "매장",
    key: "pos",
  },
  {
    label: "키오스크",
    key: "kiosk",
  },
  {
    label: "테이블오더",
    key: "menuorder",
  },
  {
    label: "어라운드마켓",
    key: "market",
  },
  {
    label: "쿠팡이츠",
    key: "coupang",
  },
  {
    label: "배달의 민족",
    key: "baemin",
  },
  {
    label: "요기요",
    key: "yogiyo",
  },
  {
    label: "카페24",
    key: "cafe24",
  },
];

export const ORDER_SUB_ORIGIN = [
  {
    label: "배달의 민족(배민1)",
    key: "baemin1",
  },
  {
    label: "그로잉세일즈 미니",
    key: "mini",
  },
];

export const PROVIDERORDER_ORIGIN = [
  {
    label: "매장",
    key: "pos",
  },
  {
    label: "키오스크",
    key: "kiosk",
  },
  {
    label: "카페24",
    key: "cafe24",
  },
];

export const ORDER_ORIGIN_FOR_REPORT = [
  {
    label: "매장",
    key: "pos",
  },
  {
    label: "키오스크",
    key: "kiosk",
  },
  {
    label: "테이블오더",
    key: "menuorder",
  },
  {
    label: "어라운드마켓",
    key: "market",
  },
  {
    label: "배달주문",
    key: "delivery",
  },
];

export const PAYMENT_METHOD_FOR_REPORT = [
  {
    label: "현금",
    key: "cash",
  },
  {
    label: "카드",
    key: "card",
  },
  {
    label: "간편결제",
    key: "barcode",
  },
  {
    label: "기타수단",
    key: "extra",
  },
  {
    label: "선불/외상금",
    key: "credit",
  },
];

export const ORDER_ORIGIN_FOR_REPORT_BY_KEY = ORDER_ORIGIN_FOR_REPORT.reduce(
  (obj, o) => {
    obj[o.key] = o;
    return obj;
  },
  {},
);

export const ORDER_ORIGIN_BY_KEY = ORDER_ORIGIN.reduce((obj, o) => {
  obj[o.key] = o;
  return obj;
}, {});

export const PAYMENT_METHOD_FOR_REPORT_BY_KEY =
  PAYMENT_METHOD_FOR_REPORT.reduce((obj, m) => {
    obj[m.key] = m;
    return obj;
  }, {});

export const DATA_COLOR_KEY = {
  method: {
    card: "#006AFF",
    cash: "#3b8dff",
    extra: "#7eb4ff",
    barcode: "#b1d2ff",
    credit: "#d7e8ff",
  },
  origin: {
    pos: "#191D88",
    delivery: "#48D1CC",
    baemin: "#48D1CC",
    coupang: "#7E3F21",
    yogiyo: "#F50048",
    market: "#F4A261",
    kiosk: "#1450A3",
    menuorder: "#337CCF",
    cafe24: "#FFC436",
  },
};

export const LANGUAGE_OPTIONS = [
  { text: "🇰🇷 한국어", value: "ko" },
  { text: "🇺🇸 영어", value: "en" },
  { text: "🇨🇳 중국어", value: "zh" },
  { text: "🇯🇵 일본어", value: "ja" },
];

export const INVENTORY_REASON_OPTIONS = [
  {
    value: "newStock",
    label: "입고",
    description: "재고 수량을 증가시키며, 단가는 매출원가에 반영됩니다.",
    hasUpload: true,
  },
  {
    value: "remove",
    label: "임의차감",
    description: "재고 수량만 차감되며, 판매로 취급되지 않습니다.",
    hasUpload: true,
  },
  {
    value: "add",
    label: "임의증가",
    description: "재고 수량만 증가되며, 판매로 취급되지 않습니다.",
    hasUpload: true,
  },
  {
    value: "force",
    label: "임의 조정",
    description: "재고 수량을 임의로 지정합니다.",
  },
  {
    value: "damaged",
    label: "파손처리",
    description: "가용 재고 수량에서 차감되며, 불용재고로 분류됩니다.",
  },
  {
    value: "loss",
    label: "손실처리",
    description: "재고 수량을 차감하며, 비용으로 처리됩니다.",
    hasUpload: true,
  },
];

export const INVENTORY_TRANSACTION_REASONS = [
  { value: "sales", label: "판매" },
  { value: "damaged", label: "파손 재고" },
  { value: "loss", label: "손실 재고" },
  { value: "remove", label: "임의차감" },
  { value: "add", label: "임의증가" },
  { value: "newStock", label: "입고" },
  { value: "restock", label: "재입고" },
  { value: "returns", label: "반품입고" },
  { value: "transfer", label: "지점이동" },
  { value: "force", label: "임의조정" },
  { value: "exchange", label: "교환" },
];

export const INVENTORY_TRANSACTION_BY_REASON =
  INVENTORY_TRANSACTION_REASONS.reduce((obj, r) => {
    obj[r.value] = r;
    return obj;
  }, {});

export const TABLE_HEADER_FOR_TRANSFER_HISTORY = [
  {
    label: "제품",
    width: "18%",
    key: "prodName",
  },
  {
    label: "하위제품",
    width: "18%",
    key: "skuName",
  },
  {
    label: "바코드",
    width: "17%",
    key: "unit",
  },
  {
    label: "품목코드(SKU)",
    width: "17%",
    key: "model",
  },
  {
    label: "이동수량",
    width: "15%",
    key: "quantity",
  },
  {
    label: "입고(예정)수량",
    width: "15%",
    key: "receivedQuantity",
  },
];

export const TABLE_HEADER_FOR_COUNT_HISTORY = [
  {
    label: "제품이름",
    width: "15%",
    key: "prodName",
  },
  {
    label: "하위제품",
    width: "15%",
    key: "skuName",
  },
  {
    label: "바코드",
    width: "13%",
    key: "unit",
  },
  {
    label: "품목코드(SKU)",
    width: "13%",
    key: "model",
  },
  {
    label: "이전 수량",
    width: "10%",
    key: "prevQuantity",
    isQty: true,
    func: numberWithCommas,
  },
  {
    label: "실사수량",
    width: "10%",
    key: "currQuantity",
    isQty: true,
    func: numberWithCommas,
  },
  {
    label: "수량차이",
    width: "10%",
    key: "diff",
    isQty: true,
    func: numberWithCommas,
  },
  {
    label: "비용차이",
    width: "14%",
    key: "totalCost",
    isBold: true,
    isAmount: true,
    func: numberToCurrency,
  },
];

export const CREDIT_CHARGE_LIST = [
  {
    quantity: 3000,
    amount: 15000,
  },
  {
    quantity: 5000,
    amount: 25000,
  },
  {
    quantity: 10000,
    amount: 50000,
  },
  {
    quantity: 20000,
    amount: 90000,
    discount: 0.1,
  },
  {
    quantity: 50000,
    amount: 225000,
    discount: 0.1,
  },
  {
    quantity: 100000,
    amount: 435000,
    discount: 0.13,
  },
];

export const RETURN_REASON = [
  {
    key: "accidental_charge",
    label: "결제 실수",
  },
  {
    key: "product_malfunction",
    label: "제품 불량",
  },
  {
    key: "canceled_order",
    label: "주문 취소",
  },
  {
    key: "fraudulent_charge",
    label: "사기 거래",
  },
  {
    key: "extra",
    label: "기타",
  },
];

export const CUSTOMER_EVENT_GUIDE = {
  instagram: (
    <>
      <div className="h5 bold">
        인스타그램 계정 링크
        <div className="h6 normal">
          고객이 인스타그램 계정으로 바로 이동할 수 있도록
          <br />
          아래 이미지와 같이 계정 URL을 복사하여 입력해 주세요.
          <br />
          <br />
          <img
            alt="instagram"
            style={{ width: "100%" }}
            src={require("../img/guide/instagram_url.png")}
          />
        </div>
      </div>
    </>
  ),
  instagramId: (
    <>
      <div className="h5 bold">
        인스타그램 계정 아이디
        <div className="h6 normal">
          고객이 스토리 링크 업로드시 브랜드 인스타그램을 태그할 수 있도록
          <br />
          아래 이미지의 인스타그램 계정 아이디를 입력해 주세요.
          <br />
          <br />
          <img
            alt="instagram"
            style={{ width: "100%" }}
            src={require("../img/guide/instagram_id.png")}
          />
        </div>
      </div>
    </>
  ),
  kakao: (
    <>
      <div className="h5 bold">
        카카오 비즈니스채널 링크
        <div className="h6 normal">
          고객이 브랜드 비즈니스채널을 추가할 수 있도록
          <br />
          아래 이미지의 채널 링크를 복사하여 입력해 주세요.
          <br />
          <br />
          <img
            alt="instagram"
            style={{ width: "100%" }}
            src={require("../img/guide/kakao_url.png")}
          />
        </div>
      </div>
    </>
  ),
  cafe24: (
    <>
      <div className="h5 bold">
        자사몰 가입링크
        <div className="h6 normal">
          비회원 고객이 브랜드 자사몰에 가입할 수 있도록 가입 URL을 입력해
          주세요.
          <br />
          <br />
          <img
            alt="instagram"
            style={{ width: "100%" }}
            src={require("../img/guide/cafe24_url.png")}
          />
        </div>
      </div>
    </>
  ),
};

export const CAFE24_HELP_GUIDE = {
  type: (
    <>
      <div className="h5 bold">
        품목코드란,
        <div className="h6 normal">
          카페24에서 제공하는 기본 상품코드로 아래 이미지와 같습니다.
          <br />
          옵션제품이 없는 경우, <b>기본정보에 있는 상품코드</b>를 매칭하며
          <br />
          옵션제품이 있는 경우, 옵션제품별 <b>품목코드</b>를 매칭합니다.
          <br />
          <img
            style={{ width: "100%" }}
            src={require("../img/cafe24/id-guide.png")}
          />
        </div>
      </div>
      <div className="h5 bold mt-line">
        자체 품목코드란,
        <div className="h6 normal">
          사업자가 직접 설정하신 자체 상품코드를 말하며,
          <br />
          옵션제품이 없는 경우, <b>기본정보에 있는 자체 상품코드</b>를 매칭하며
          <br />
          옵션제품이 있는 경우, 옵션제품별 <b>자체 품목코드</b>를 매칭합니다.
          <br />
          <img
            style={{ width: "100%" }}
            src={require("../img/cafe24/model-guide.png")}
          />
        </div>
      </div>
    </>
  ),
  includesType: (
    <>
      <div className="h5 bold">
        상품코드란,
        <div className="h6 normal">
          카페24에서 제공하는 기본 상품코드로 아래 이미지와 같습니다.
          <br />
          <img
            style={{ width: "100%" }}
            src={require("../img/cafe24/productId-guide.png")}
          />
        </div>
      </div>
    </>
  ),
  method: (
    <>
      <div className="h5 bold">
        [자동동기화]
        <div className="h6 normal">
          - 카페24의 상품정보들과 그로잉세일즈에 저장돼 있는 상품정보들을
          비교합니다.
          <br />
          - 비교 후 그로잉세일즈에서 조회되지 않는다면 신규 생성을 진행합니다.
          <br />
          <img
            style={{ width: "100%" }}
            src={require("../img/cafe24/method1.png")}
          />
        </div>
        <div className="mt-small" />
        <div className="h6 normal">
          - 반대로 그로잉세일즈에 이미 연동돼 있는 상품이 있다면, 카페24의
          상품정보와 비교합니다.
          <br />
          - 만약 카페24에서 상품이 삭제됐다면, 자동으로 연동이 해제됩니다.
          <br />
          - 연동이 해제되더라도, 그로잉세일즈에는 상품정보는 그대로 유지됩니다.
          <br />
          <img
            style={{ width: "100%" }}
            src={require("../img/cafe24/method2.png")}
          />
        </div>
      </div>
    </>
  ),
  unlink: (
    <>
      <img
        style={{ width: "100%" }}
        src={require("../img/cafe24/unlink_on.png")}
      />

      <div className="mt-small" />

      <img
        style={{ width: "100%" }}
        src={require("../img/cafe24/unlink_off.png")}
      />
    </>
  ),
};

export const IMWEB_HELP_GUIDE = {
  ...CAFE24_HELP_GUIDE,
  type: (
    <>
      <div className="h5 bold">
        품목코드란,
        <div className="h6 normal">
          아임웹이 내부적으로 자동 생성해두는 <b>기본 품목 코드</b>입니다.
          <br />
          아임웹 관리자 화면에는 노출되지 않지만, 시스템상 모든 상품 또는
          옵션상품에 부여되어 있어요.
          <br />
          그로잉세일즈에서 <b>품목코드</b>로 연동을 진행하면 이 코드가 그대로
          가져와져 SKU로 사용됩니다.
        </div>
      </div>
      <div className="h5 bold mt-line">
        재고번호(SKU)란,
        <div className="h6 normal">
          사업자가 아임웹 상품 등록 시 직접 입력한 <b>재고번호(SKU)</b>입니다.
          <br />
          옵션이 없는 상품은 상품 단위로 입력한 재고번호(SKU),
          <br />
          옵션이 있는 상품은 옵션별로 입력한 재고번호(SKU)를 의미합니다.
          <br />
          그로잉세일즈에서 <b>재고번호(SKU)</b>로 연동을 진행하면 직접 입력하신
          SKU가 그대로 그로잉세일즈로 가져와집니다.
          <br />
          <img
            style={{ width: "100%" }}
            src={require("../img/imweb/model-guide.png")}
          />
        </div>
      </div>
    </>
  ),
  includesType: (
    <>
      <div className="h5 bold">
        상품번호란,
        <div className="h6 normal">
          아임웹에서 상품마다 자동으로 부여하는 <b>고유 번호</b>입니다.
          <br />
          제품필터에는 동기화할 아임웹 상품번호를 입력해 주세요.
          <br />
          <img
            style={{ width: "100%", marginTop: "12px" }}
            src={require("../img/imweb/productId-guide.png")}
          />
        </div>
      </div>
    </>
  ),
  unlink: (
    <>
      <img
        style={{ width: "100%" }}
        src={require("../img/imweb/unlink_on.png")}
      />
      <img
        style={{ width: "100%" }}
        src={require("../img/imweb/unlink_off.png")}
      />
    </>
  ),
};

export const PROVIDER_PRODUCT_SYNC_HELP_GUIDE = {
  cafe24: CAFE24_HELP_GUIDE,
  imweb: IMWEB_HELP_GUIDE,
};

export const CAFE24_INVENTORY = {
  standard: (
    <div>
      <img
        style={{ width: "100%" }}
        alt="help"
        src={require("../img/cafe24/cafe24_inventory_standard.png")}
      />
    </div>
  ),
};

export const ORDER_HELP_GUIDES = {
  stat: (
    <div className="flex-column" style={{ gap: "10px" }}>
      <div>
        <div className="h5">통계데이터 표시</div>
        <div className="h6">
          설정한 필터값에 따라 조회결과 제공시 아래 통계데이터가 함께
          표시됩니다.
        </div>
      </div>
      <br />
      <div>
        <div className="h6-medium bold">일반 조회</div>
        <div className="h6">
          - 총 주문수, 총 결제금액, 총 미결제금액, 총 할인금액, 총 환불금액
        </div>
      </div>
      <div>
        <div className="h6-medium bold">환급 필터</div>
        <div className="h6">- 즉시환급액, 사후환급액</div>
      </div>
      <div>
        <div className="h6-medium bold">선불금 필터</div>
        <div className="h6">- 선불금 사용액, 선불금 충전액</div>
      </div>
      <div>
        <div className="h6-medium bold">주문제품 조회</div>
        <div className="h6">- 총 판매수량, 총 반품수량</div>
      </div>
    </div>
  ),
};

export const REPORT_HELP_GUIDES = {
  standard: (
    <div className="h5">
      매출 기준: <b>총 판매금액 - 총 환불금액</b>
      <br />
      <br />
      결제금액 기준: 고객의 최종 결제금액,
      <b> 실결제금액 또는 순매출에 해당</b>
    </div>
  ),
  newCount: (
    <div className="h5">
      현금으로 결제한 고객 혹은 새로운 결제수단(카드, 간편결제 등)을 사용한
      고객들이 신규고객으로 분류됩니다.
    </div>
  ),
  revisitCount: (
    <div className="h5">
      (재방문한 등록고객 + 동일카드*로 결제하신 손님) / 전체 주문 수
      <br />* 동일카드란, 이전 매장에서 동일한 카드로 결제했던 이력이 있는
      카드를 말합니다.
    </div>
  ),
  pointUse: (
    <div className="h5">
      00시 포인트 만료처리로 사용데이터가 많아 보일수 있습니다.
      <br />
      유효기간이 지난 포인트의 만료도 사용처리로 집계됩니다.
    </div>
  ),
  method: (
    <div className="h5">
      <b>카드사 조회시 유의사항</b>
      <br />
      그로잉세일즈 앱 81버전, PC 43버전부터 조회가능합니다.
      <br />
      <br />
      <b>기타수단 조회시 유의사항</b>
      <br />
      기타수단 결제시 이름이 입력된 수단만 집계됩니다.
    </div>
  ),
  cost: (
    <div className="h5">
      <b>매출원가 조회시 유의사항</b>
      <br />
      판매표 내 매출원가는 현재 제품정보에 저장된 단가를 기준으로 계산되며,
      단가를 변경할시 매출원가 정보가 변경될 수 있습니다.
      <br />
      선입선출 방식의 매출원가 리포트는 재고리포트에서 조회 가능합니다.
      <br />
    </div>
  ),
  timeSpan: {
    title: "시간 구간",
    body: (
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th>구간명</th>
            <th>시간대</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>오전 시간대</td>
            <td>09:00 ~ 11:59</td>
          </tr>
          <tr>
            <td>점심/이후</td>
            <td>12:00 ~ 14:59</td>
          </tr>
          <tr>
            <td>이른 오후</td>
            <td>15:00 ~ 16:59</td>
          </tr>
          <tr>
            <td>퇴근/저녁 전</td>
            <td>17:00 ~ 18:59</td>
          </tr>
          <tr>
            <td>저녁 피크</td>
            <td>19:00 ~ 21:59</td>
          </tr>
          <tr>
            <td>야간</td>
            <td>22:00 ~ 23:59</td>
          </tr>
        </tbody>
      </table>
    ),
  },
};

export const CHERRY_GUIDE = {
  cherry: (
    <div className="h6">
      <b>현재등급</b>: 마지막 등급 업데이트후 조정된 등급
      <br />
      <br />
      <b>추정등급</b>: 현재 주문(결제, 환불내역)을 기준으로 등급업데이트 반영시
      추정되는 등급산정시
      <br />
      <br />
      <b>등급산정시 결제금액</b>: 마지막 등급 업데이트시 반영된 실결제금액
      <br />
      <br />
      <b>등급산정후 환불금액</b>: 마지막 등급 업데이트시 반영된 주문 중
      환불처리된 결제금액
      <br />
      <br />
      <b>등급산정후 결제금액</b>: 마지막 등급 업데이트 이후 추가된 결제금액
      <br />
      등급 산정후 결제금액은 지난 등급 업데이트시 산정된 결제금액 중 부득이한
      사정으로 환불한 경우가 있을수 있으므로, 추가된 결제금액을 참조하여
      체리피커 여부를 판단하기 위해 제공되는 데이터임
    </div>
  ),
};

export const EVENT_REPORT_GUIDE = {
  timeSpan: {
    title: "시간 구간",
    body: (
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th>구간명</th>
            <th>시간대</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>오전 시간대</td>
            <td>09:00 ~ 11:59</td>
          </tr>
          <tr>
            <td>점심/이후</td>
            <td>12:00 ~ 14:59</td>
          </tr>
          <tr>
            <td>이른 오후</td>
            <td>15:00 ~ 16:59</td>
          </tr>
          <tr>
            <td>퇴근/저녁 전</td>
            <td>17:00 ~ 18:59</td>
          </tr>
          <tr>
            <td>저녁 피크</td>
            <td>19:00 ~ 21:59</td>
          </tr>
          <tr>
            <td>야간</td>
            <td>22:00 ~ 23:59</td>
          </tr>
        </tbody>
      </table>
    ),
  },
  pageVisit: {
    title: "페이지 접속 수",
    body: (
      <div className="h6">
        페이지에 접속했던 참여자의 세션수를 수집합니다.
        <br />
        만약 회원인증을 한 경우, 기존 익명의 참여자 세션은 지우고 인증된 회원의
        세션을 기록하여 1명으로 기록됩니다.
        <br />
        단, 회원인증없이 참여자가 여러개 브라우저를 통해 참여할 경우 페이지에
        접속할 경우, 중복집계됩니다.
      </div>
    ),
  },
  sales: {
    title: "이벤트 참여자 매출",
    body: (
      <div className="h6">
        이벤트 참여자 매출은 참여자가 수령한 리워드를 사용한 주문건의 결제금액
        데이터입니다.
        <br />
        따라서 이벤트 참여자가 리워드를 사용하지 않고 결제만 한 경우에는 참여자
        매출에 포함되지 않습니다.
        <br />
        일반매출은 이벤트 리워드가 사용되지 않은 나머지 주문들의 결제금액
        합입니다.
      </div>
    ),
  },
  conversion: {
    title: "전환율",
    body: (
      <div className="h6">전환율 = 리워드 수령 참여자 수 / 페이지 접속 수</div>
    ),
  },
  newMember: {
    title: "신규가입고객 집계",
    body: (
      <div className="h6">
        이벤트 생성시 입력하셨던 가입 URL이 <b>자사몰 가입링크</b>여야만
        동작합니다.
        <br />
        이벤트 활성화시 입력하신 가입 URL로 추적가능한 스크립트 코드를 삽입하여
        신규가입 추적이 가능하도록 합니다.
        <br />
        단, 고객이 이벤트 페이지에서 회원가입하기 버튼을 클릭하여 이동했을때만
        추적이 가능하며,
        <b>
          별도 브라우저를 열어 자사몰을 검색 후 가입시에는 추적이 불가합니다.
        </b>
      </div>
    ),
  },
};

export const BARCODE_PRINT_GUIDE = {
  discountPrice: {
    title: "할인금액 추가방법",
    body: (
      <div className="h6">
        할인금액 추가시 텍스트 박스에 {`{{discountPrice}}`}만 명시돼야 합니다.
        <br />
        다른 옵션키와 동시 사용시 적용되지 않습니다.
        <br />
        할인조건 입력은 할인율은 (예: 3%) 로만 기입하며, 할인금액의 경우, 숫자만
        입력해야 합니다.
      </div>
    ),
  },
};

export const MEMBERSHIP_REPORT_GUIDE = {
  tierSales: {
    title: "등급별 결제금액",
    body: (
      <div className="h6">
        등급별 결제금액은 온라인 자사몰과 그로잉세일즈로 운영하는 매장에서
        발생된 주문을 분석하여 산출합니다.
        <br />
        조회시점 기준으로 각 등급의 고객 주문을 취합합니다.
        <br />
        예) 현재 VIP 등급인 고객이 조회시점에 SILVER 인 경우, SILVER
        결제금액으로 분류
      </div>
    ),
  },
  point: {
    title: "적립금 통계",
    body: (
      <div className="h6">
        적립금 통계는 매장에서의 적립금 적립/사용내역으로 산출되며, 결제완료
        상태인 주문건만 포함됩니다.
      </div>
    ),
  },
  storeSales: {
    title: "매장 멤버십 통계",
    body: (
      <div className="h6">
        매장에서의 회원/비회원 결제금액은 주문건의 결제금액을 최종결제일시
        기준으로 산출합니다.
        <br />
        만일 분할결제, 교환 주문의 경우 최종 결제일시 기준으로 매장별 결제금액을
        산출하기 때문에 주문내역의 결제금액 합과 상이할 수 있습니다.
        <br />
        탈퇴한 회원의 경우, 조회시점에는 회원으로 주문을 하였기 때문에 통계에
        포함됩니다.
      </div>
    ),
  },
  omni: {
    title: "온・오프라인 회원 식별",
    body: (
      <div className="h6">
        조회한 기간동안 온라인과 오프라인에서 모두 구매한 회원은 다른 분류에
        포함되지 않고 <b>온・오프라인 모두 구매한 회원</b>으로만 집계됩니다.
      </div>
    ),
  },
  guest: {
    title: "비회원 구매 통계",
    body: (
      <div className="h6">
        회원이 아닌 비회원의 온라인, 오프라인 주문의 결제금액 통계입니다.
      </div>
    ),
  },
  genderSales: {
    title: "성별 방문데이터",
    body: (
      <div className="h6">
        고객의 자사몰 회원가입시 성별 정보 기입시 통계데이터가 산출됩니다.
      </div>
    ),
  },
  ageSales: {
    title: "연령별 방문데이터",
    body: (
      <div className="h6">
        고객의 자사몰 회원가입시 연령별 정보 기입시 통계데이터가 산출됩니다.
      </div>
    ),
  },
};

export const CRM_REPORT_GUIDE = {
  roas: {
    title: "ROAS",
    body: (
      <div className="h6">
        ROAS(Return On Ad Spend) 산출식
        <br />
        ROAS = 총 기여금액 / 광고비 × 100 (%)
        <br />총 기여금액은 메시지 발송 후 72시간 내의 구매만 집계
        <br />
        ex) 발송비용 10만원을 써서 기여금액 30만원을 발생했을 경우 ROAS는 300%
      </div>
    ),
  },
  campaignFailure: {
    title: "발송 실패 수",
    body: (
      <div className="h6">
        발송 요청 대비 실패한 건수입니다.
        <br />
        수신 거부, 번호 오류, 채널 정책 위반 등의 사유로 실패가 발생할 수
        있습니다.
        <br />
        실패시 발송에 소요됐던 비용(캔디)는 환불처리 됩니다.
      </div>
    ),
  },
  initSales: {
    title: "초기 전환",
    body: (
      <div className="h6">
        캠페인 수신 후 48시간 내 결제를 진행한 고객의 주문 수
      </div>
    ),
  },
  subsequentSales: {
    title: "후속 전환",
    body: (
      <div className="h6">
        캠페인 수신 후 72시간 내 결제를 진행한 고객의 주문 수 (48시간 ~ 72시간)
        <br />
        초기전환과 중복집계 되지 않음
      </div>
    ),
  },
  sales: {
    title: "기여금액",
    body: (
      <div className="h6">
        총 전환된 주문의 실 결제금액의 합
        <br />
        (문자 수신 후 72시간 내 구매 전환만 집계)
      </div>
    ),
  },
};

export const DISCOUNT_REPORT_GUIDE = {
  storeDiscount: {
    title: "일반 할인",
    body: (
      <div className="h6">
        매장에서 주문에 직접 적용되는 일반/자동 할인이 해당됩니다.
      </div>
    ),
  },
  couponDiscount: {
    title: "쿠폰사용",
    body: (
      <div className="h6">
        그로잉세일즈에서 생성한 바코드 쿠폰과
        <br />
        온라인 자사몰에서 생성한 프로모션 쿠폰이 해당됩니다.
      </div>
    ),
  },
  duplication: {
    title: "할인금액 산출방법",
    body: (
      <div className="h6">
        한 주문안에 여러 유형의 할인이 동시에 적용되서 처리된 경우,
        <br />
        전체 할인금액과 개별 할인금액의 합이 다를 수 있습니다.
        <br />
        <br />
        한 주문에 쿠폰 + 포인트 등 여러 할인이 동시 적용된 경우:
        <br />- 사용횟수: 각 할인 유형별로 독립 카운트 (중복 허용). 예) 쿠폰 1회
        + 포인트 1회 → 각각 +1
        <br />- 할인금액: 각 할인 유형별 주문에 적용된 할인금액
        <br />- 결제금액: 해당 할인 유형이 적용된 주문의 결제금액의 합. 한
        주문에 쿠폰+포인트가 동시 적용되면, 해당 주문의 결제금액이 쿠폰/포인트
        양쪽 모두에 집계됨. 단, 전체 할인금액에서는 한 번만 집계.
      </div>
    ),
  },
};

export const CUSTOMER_REPORT_GUIDE = {
  inactive: {
    title: "휴면회원",
    body: (
      <div className="h6">
        365일(1년) 동안 매장/온라인 자사몰에서 주문이 없는 회원
      </div>
    ),
  },
  revisitRate: {
    title: "재방문율",
    body: <div className="h6">기간 내 기존 회원의 주문 수 / 기간 내 총 주문 수</div>,
  },
  NEW_MEMBER: {
    title: "신규회원",
    body: <div className="h6">회원 중 첫 구매를 하신 고객</div>,
  },
  EXISTING_MEMBER: {
    title: "기존 회원",
    body: (
      <div className="h6">회원 중 첫 구매가 아닌 2번째 구매 이상인 고객</div>
    ),
  },
  newLocationMember: {
    title: "매장 첫 방문 고객",
    body: (
      <div className="h6">
        - 회원들 중 해당 매장에 처음 방문한 고객의 수
        <br />- 타매장에 방문한 이력이 있어도 집계될 수 있습니다.
        <br />- 해당 매장에서 처음 가입하면서 처음 구매한 고객도 포합됩니다.
      </div>
    ),
  },
};

export const PROVIDER_CONDITION_OPTIONS = [
  {
    value: "tier",
    label: "고객등급",
    field: "tier",
    object: "customer",
  },
  {
    value: "origin",
    label: "주문처",
    field: "origin",
    object: "order",
  },
];

export const CONDITION_OPTIONS = [
  {
    value: "lastVisit",
    label: "마지막 주문일",
    field: "createdAt",
    object: "order",
  },
  {
    value: "orderAmount",
    label: "결제금액",
    field: "amount",
    object: "pay",
  },
  {
    value: "refundAmount",
    label: "환불금액",
    field: "amount",
    object: "pay",
  },
  {
    value: "visitCount",
    label: "총 주문횟수",
    field: "count",
    object: "order",
  },
  {
    value: "orderCreatedAt",
    label: "주문기간",
    field: "orderCreatedAt",
    object: "order",
  },
  {
    value: "productId",
    label: "구매제품",
    field: "productId",
    object: "product",
  },
  {
    value: "productName",
    label: "구매제품이름",
    field: "productName",
    object: "product",
  },
  {
    value: "categoryName",
    label: "구매카테고리이름",
    field: "categoryName",
    object: "product",
  },
  {
    value: "couponId",
    label: "쿠폰사용여부",
    field: "couponId",
    object: "order",
  },
];

export const CONDITION_OPTIONS_FOR_MULTI = [
  {
    value: "orderLocationId",
    label: "방문지점",
    field: "orderLocationId",
    object: "order",
  },
  {
    value: "brandId",
    label: "방문브랜드",
    field: "brandId",
    object: "order",
  },
];

export const OBJECT_OPTIONS = [
  { value: "order", label: "주문조건" },
  { value: "pay", label: "결제조건" },
  { value: "customer", label: "고객조건" },
  { value: "product", label: "제품조건" },
];

export const getConditionLabelByKey = (key) => {
  let conditionsByKey = [
    ...PROVIDER_CONDITION_OPTIONS,
    ...CONDITION_OPTIONS_FOR_MULTI,
  ].reduce((obj, c) => {
    obj[c.value] = c.label;
    return obj;
  }, {});
  return conditionsByKey[key] ? conditionsByKey[key] : "";
};

export const ORIGIN_LABELS = {
  cafe24: {
    label: "온라인 주문(자사몰)",
    value: "cafe24",
  },
  pos: {
    label: "매장 포스",
    value: "pos",
  },
};

export const OPERATION_LABEL = {
  gte: "이상",
  lte: "이하",
  gt: "초과",
  lt: "미만",
  eq: "일치",
  ne: "불일치",
  contains: "포함",
  in: "포함",
};

export const OPERATION_LABEL_FOR_DATE = {
  gt: "이후",
  lt: "이전",
  gte: "이후",
  lte: "이전",
  between: "동안",
  recent: "이내",
};

export const RECENT_PERIOD_UNIT_OPTIONS = [
  { value: "W", text: "주" },
  { value: "M", text: "개월" },
];

// "1W" -> "최근 1주", "3M" -> "최근 3개월"
export const formatRecentPeriodValue = (value) => {
  if (!value) return "";
  const match = /^(\d+)([WM])$/.exec(value);
  if (!match) return value;
  const unit = match[2] === "W" ? "주" : "개월";
  return `최근 ${match[1]}${unit}`;
};

export const OPERATION_LABEL_FOR_LOCATION = {
  eq: "포함",
  ne: "미포함",
};

export const CONDITION_OPERATION = {
  orderAmount: [
    {
      operation: "gte",
      type: "number",
      value: null,
    },
    {
      operation: "lte",
      type: "number",
      value: null,
    },
  ],
  refundAmount: [
    {
      operation: "gte",
      type: "number",
      value: null,
    },
    {
      operation: "lte",
      type: "number",
      value: null,
    },
  ],
  lastVisit: [
    {
      operation: "recent",
      type: "string",
      value: null,
    },
    {
      operation: "between",
      type: "json",
      value: [],
    },
  ],
  visitCount: [
    {
      operation: "gte",
      type: "number",
      value: null,
    },
    {
      operation: "lte",
      type: "number",
      value: null,
    },
  ],
  tier: [
    {
      operation: "in",
      type: "json",
      value: [],
    },
  ],
  orderLocationId: [
    {
      operation: "eq",
      type: "string",
      value: null,
    },
  ],
  brandId: [
    {
      operation: "eq",
      type: "string",
      value: null,
    },
  ],
  origin: [
    {
      operation: "ne",
      type: "string",
      value: null,
    },
    {
      operation: "eq",
      type: "string",
      value: null,
    },
  ],
  orderCreatedAt: [
    {
      operation: "recent",
      type: "string",
      value: null,
    },
    {
      operation: "between",
      type: "json",
      value: [],
    },
  ],
  productId: [
    {
      operation: "eq",
      type: "string",
      value: null,
    },
  ],
  productName: [
    {
      operation: "contains",
      type: "string",
      value: null,
    },
  ],
  categoryName: [
    {
      operation: "contains",
      type: "string",
      value: null,
    },
  ],
  couponId: [
    {
      operation: "eq",
      type: "string",
      value: null,
    },
  ],
};

export const MESSAGE_LIMIT_LENGTH = {
  sms: 90,
  lms: 2000,
  mms: 2000,
  wide: 150,
  normal: 800,
  title: 40,
};

export const MONTH_OPTIONS = [
  {
    value: "1",
    label: "1월",
  },
  {
    value: "2",
    label: "2월",
  },
  {
    value: "3",
    label: "3월",
  },
  {
    value: "4",
    label: "4월",
  },
  {
    value: "5",
    label: "5월",
  },
  {
    value: "6",
    label: "6월",
  },
  {
    value: "7",
    label: "7월",
  },
  {
    value: "8",
    label: "8월",
  },
  {
    value: "9",
    label: "9월",
  },
  {
    value: "10",
    label: "10월",
  },
  {
    value: "11",
    label: "11월",
  },
  {
    value: "12",
    label: "12월",
  },
];

export const getAlimtalkTemplateLabel = (templateCode) => {
  switch (templateCode) {
    case "regularCustomerCoupon":
      return "단골손님 쿠폰 발송";
    case "monthCoupon":
      return "월간 쿠폰 발송";
    default:
      return "";
  }
};

export const getAlimtalkImage = (templateCode) => {
  switch (templateCode) {
    case "regularCustomerCoupon":
      return require("../img/campaign/regular-coupon.png");
    case "monthCoupon":
      return require("../img/campaign/month-coupon.png");
    default:
      return "";
  }
};

export const SHIPPING_COMPANY_BY_CODE = {
  6: "CJ대한통운",
  12: "우체국택배",
  13: "우체국(등기,소포 우편)",
  18: "한진택배",
  19: "롯데택배",
  1076: "농협택배",
  1078: "CU편의점택배",
  62: "GS Postbox(CVSnet)",
  75: "TNT 익스프레스",
  4: "로젠택배",
  16: "일양택배",
  5: "삼성택배(HTH)",
  2: "건영택배",
  7: "아주택배",
  9: "오렌지택배",
  10: "오세기고구려",
  11: "용마로지스",
  14: "이젠택배",
  15: "이클라인",
  17: "트라넷",
  21: "KGB특급택배",
  22: "KGB택배",
  23: "KL-Net 택배",
  24: "LOEX 택배",
  25: "일반택배",
  26: "DHL",
  27: "FedEx",
  28: "UPS",
  29: "국제특급 EMS",
  30: "국제특급 EMS 프리미엄",
  31: "국제항공소포",
  32: "국제선편소포",
  33: "선편소형포장물",
  34: "항공소형포장물",
  35: "SAL소포",
  36: "벨익스프레스",
  37: "우리택배",
  38: "코덱스택배",
  39: "경동택배",
  40: "스피디익스프레스",
  41: "고구려택배",
  42: "양양택배",
  43: "대신택배",
  44: "천일택배",
  45: "하이브랜로지스",
  46: "호남택배",
  47: "동서택배",
  48: "한국택배",
  49: "이트랜스택배",
  50: "이패밀리",
  51: "하나로택배",
  52: "WPX택배",
  53: "메일렉스코리아",
  55: "SEDEX(신세계)",
  56: "SC로지스",
  57: "굿모닝택배",
  58: "정안CLS",
  59: "AirboyExpress",
  60: "퀵퀵닷컴",
  61: "이노지스",
  63: "위즈와",
  64: "포시즌익스프레스",
  65: "인로스",
  66: "USX 국제특송",
  67: "한진화물",
  68: "ACI Express",
  69: "바익스",
  70: "인티박스",
  71: "USPS",
  72: "First Air Express",
  73: "hddt(HDL)",
  74: "GTX 로지스",
  76: "GSM",
  77: "합동택배",
  78: "GPS lgx",
  79: "롯데글로벌로지스",
  80: "MIT EXPRESS CO., LTD",
  81: "FASTBOX",
  82: "CAINIAO",
  83: "사가와 익스프레스(SAGAWA EXPRESS)",
  84: "야마토 운송(YAMATO TRANSPORT)",
  85: "순평(SF)",
  86: "LX판토스",
  87: "RINCOS",
  88: "야마토택배",
  89: "STO Express",
  90: "한진 Fedex",
  91: "사가와택배(飛脚宅配便)",
  93: "중통택배",
  94: "OCS",
  95: "WEX24(SMART POST)",
  96: "야마토(黑貓宅急便)",
  98: "Japan Post Service (EMS)",
  99: "고쿠사이 익스프레스",
  107: "Seino Transportation",
  213: "SLX택배",
  214: "한의사랑",
  215: "한덱스",
  216: "굿투럭",
  217: "KGL네트웍스",
  218: "I-Parcel",
  219: "ACE Express",
  220: "성원글로벌",
  221: "스마트로지스",
  222: "큐익스프레스",
  223: "워펙스",
  224: "퍼레버택배",
  225: "우리동네택배",
  226: "자이언트",
  227: "씨웨이",
  228: "홈이노베이션",
  229: "브리지로지스",
  230: "시알로지텍",
  231: "두발히어로",
  232: "로지스파트너",
  233: "카카오 T 당일배송",
  234: "컬리넥스트마일",
  235: "투데이",
  237: "핑퐁",
  238: "ARGO",
  239: "JoomLogistics",
  240: "팀프레시",
  241: "우리한방택배",
  242: "용성종합물류",
  243: "프레딧(HY)",
  244: "딜리박스",
  245: "ENVYCUBE",
  246: "ENVYCUBE Light",
  247: "홈픽",
  248: "쉽터",
  249: "케이티 익스프레스",
  250: "홈픽 오늘도착",
  251: "Qxpress economy",
  252: "EFS",
  253: "델레오",
  1003: "CATS YTO express logistics",
  1070: "FASTBOX(연동)",
  1071: "Fastbox Mail",
  1072: "Fastbox Economy",
  1073: "Fastbox Standard",
  1074: "Fastbox Premium",
  1075: "세방택배",
  1077: "FamilyMart Pickup",
  1079: "도도플렉스당일도착",
  1080: "글로벌 해상 특송",
  1081: "Pantos",
  1082: "Qxpress",
  1083: "Qprime",
  1084: "GSI Express",
  1088: "로지스밸리(logisvalley)",
  9996: "오늘도착(원더스)",
  9997: "퀵배송",
  9998: "당일배송",
};

export const DAUM_SCRIPT_URL =
  "https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";

export const COUNTRY_FLAG_IMAGE_URL_BY_CODE = FULL_COUNTRY.reduce((obj, c) => {
  obj[c.alpha3] = c.file_url;
  return obj;
}, {});

export const COUNTRY_3_EMOJI_DICT = {
  IND: "🇮🇳",
  NGA: "🇳🇬",
  KEN: "🇰🇪",
  ITA: "🇮🇹",
  USA: "🇺🇸",
  CUB: "🇨🇺",
  GBR: "🇬🇧",
  ZAF: "🇿🇦",
  POL: "🇵🇱",
  GHA: "🇬🇭",
  MAR: "🇲🇦",
  IDN: "🇮🇩",
  ESP: "🇪🇸",
  BRA: "🇧🇷",
  DEU: "🇩🇪",
  FRA: "🇫🇷",
  ARE: "🇦🇷",
  CMR: "🇨🇲",
  MEX: "🇲🇪",
  UZB: "🇺🇿",
  IRN: "🇮🇷",
  SAU: "🇸🇦",
  TUR: "🇹🇷",
  CHL: "🇨🇱",
  TZA: "🇹🇿",
  UKR: "🇺🇦",
  NPL: "🇳🇵",
  PAK: "🇵🇰",
  PER: "🇵🇪",
  UGA: "🇺🇬",
  COL: "🇨🇴",
  AUS: "🇦🇺",
  AUT: "🇦🇹",
  ARG: "🇦🇷",
  ETH: "🇪🇹",
  CHN: "🇨🇳",
  RUS: "🇷🇺",
  PHL: "🇵🇭",
  VEN: "🇻🇪",
  MYS: "🇲🇾",
  GRC: "🇬🇷",
  CAN: "🇨🇦",
  BGD: "🇧🇩",
  ZWE: "🇿🇼",
  JPN: "🇯🇵",
  THA: "🇹🇭",
  LKA: "🇱🇰",
  ROU: "🇷🇴",
  ISR: "🇮🇱",
  VNM: "🇻🇳",
  NZL: "🇳🇿",
  NLD: "🇳🇱",
  EGY: "🇪🇬",
  ECU: "🇪🇨",
  SGP: "🇸🇬",
  DOM: "🇩🇴",
  GEO: "🇬🇪",
  DZA: "🇩🇿",
  KAZ: "🇰🇿",
  KOR: "🇰🇷",
  BEL: "🇧🇪",
  LBN: "🇱🇧",
  CZE: "🇨🇿",
  QAT: "🇶🇦",
  TJK: "🇹🇯",
  MDV: "🇲🇻",
  IRQ: "🇮🇶",
  HKG: "🇭🇰",
  SWE: "🇸🇪",
  TWN: "🇹🇼",
  AZE: "🇦🇿",
  TUN: "🇹🇳",
  ARM: "🇦🇲",
  KHM: "🇰🇭",
  KWT: "🇰🇼",
  NOR: "🇳🇴",
  HRV: "🇭🇷",
  MDA: "🇲🇩",
  FIN: "🇫🇮",
  CHE: "🇨🇭",
  ALB: "🇦🇱",
  LAO: "🇱🇦",
  PRT: "🇵🇹",
  BWA: "🇧🇼",
  BRN: "🇧🇳",
  MMR: "🇲🇲",
  DNK: "🇩🇰",
  HUN: "🇭🇺",
  IRL: "🇮🇪",
  MNG: "🇲🇳",
  SVK: "🇸🇰",
  OMN: "🇴🇲",
  LUX: "🇱🇺",
  CYP: "🇨🇾",
  BGR: "🇧🇬",
  CIV: "🇨🇮",
  BTN: "🇧🇹",
  BLR: "🇧🇾",
};

export const COUNTRIES = [
  { name: "Afghanistan", alpha2: "AF", alpha3: "AFG" },
  { name: "Albania", alpha2: "AL", alpha3: "ALB" },
  { name: "Algeria", alpha2: "DZ", alpha3: "DZA" },
  { name: "American Samoa", alpha2: "AS", alpha3: "ASM" },
  { name: "Andorra", alpha2: "AD", alpha3: "AND" },
  { name: "Angola", alpha2: "AO", alpha3: "AGO" },
  { name: "Anguilla", alpha2: "AI", alpha3: "AIA" },
  { name: "Antigua and Barbuda", alpha2: "AG", alpha3: "ATG" },
  { name: "Argentina", alpha2: "AR", alpha3: "ARG" },
  { name: "Armenia", alpha2: "AM", alpha3: "ARM" },
  { name: "Aruba", alpha2: "AW", alpha3: "ABW" },
  { name: "Australia", alpha2: "AU", alpha3: "AUS" },
  { name: "Austria", alpha2: "AT", alpha3: "AUT" },
  { name: "Azerbaijan", alpha2: "AZ", alpha3: "AZE" },
  { name: "Bahamas", alpha2: "BS", alpha3: "BHS" },
  { name: "Bahrain", alpha2: "BH", alpha3: "BHR" },
  { name: "Bangladesh", alpha2: "BD", alpha3: "BGD" },
  { name: "Barbados", alpha2: "BB", alpha3: "BRB" },
  { name: "Belarus", alpha2: "BY", alpha3: "BLR" },
  { name: "Belgium", alpha2: "BE", alpha3: "BEL" },
  { name: "Belize", alpha2: "BZ", alpha3: "BLZ" },
  { name: "Benin", alpha2: "BJ", alpha3: "BEN" },
  { name: "Bermuda", alpha2: "BM", alpha3: "BMU" },
  { name: "Bhutan", alpha2: "BT", alpha3: "BTN" },
  { name: "Bolivia", alpha2: "BO", alpha3: "BOL" },
  { name: "Bosnia and Herzegovina", alpha2: "BA", alpha3: "BIH" },
  { name: "Botswana", alpha2: "BW", alpha3: "BWA" },
  { name: "Brazil", alpha2: "BR", alpha3: "BRA" },
  { name: "British Virgin Islands", alpha2: "VG", alpha3: "VGB" },
  { name: "Brunei Darussalam", alpha2: "BN", alpha3: "BRN" },
  { name: "Bulgaria", alpha2: "BG", alpha3: "BGR" },
  { name: "Burkina Faso", alpha2: "BF", alpha3: "BFA" },
  { name: "Burundi", alpha2: "BI", alpha3: "BDI" },
  { name: "Cambodia", alpha2: "KH", alpha3: "KHM" },
  { name: "Cameroon", alpha2: "CM", alpha3: "CMR" },
  { name: "Canada", alpha2: "CA", alpha3: "CAN" },
  { name: "Cape Verde", alpha2: "CV", alpha3: "CPV" },
  { name: "Central African Republic", alpha2: "CF", alpha3: "CAF" },
  { name: "Chad", alpha2: "TD", alpha3: "TCD" },
  { name: "Chile", alpha2: "CL", alpha3: "CHL" },
  { name: "China", alpha2: "CN", alpha3: "CHN" },
  { name: "Hong Kong", alpha2: "HK", alpha3: " HKG" },
  { name: "Macao", alpha2: "MO", alpha3: "MAC" },
  { name: "Colombia", alpha2: "CO", alpha3: "COL" },
  { name: "Comoros", alpha2: "KM", alpha3: "COM" },
  { name: "Congo", alpha2: "CG", alpha3: "COG" },
  { name: "Costa Rica", alpha2: "CR", alpha3: "CRI" },
  { name: "Côte d'Ivoire", alpha2: "CI", alpha3: "CIV" },
  { name: "Croatia", alpha2: "HR", alpha3: "HRV" },
  { name: "Cuba", alpha2: "CU", alpha3: "CUB" },
  { name: "Cyprus", alpha2: "CY", alpha3: "CYP" },
  { name: "Czech Republic", alpha2: "CZ", alpha3: "CZE" },
  { name: "Denmark", alpha2: "DK", alpha3: "DNK" },
  { name: "Djibouti", alpha2: "DJ", alpha3: "DJI" },
  { name: "Dominica", alpha2: "DM", alpha3: "DMA" },
  { name: "Dominican Republic", alpha2: "DO", alpha3: "DOM" },
  { name: "Ecuador", alpha2: "EC", alpha3: "ECU" },
  { name: "Egypt", alpha2: "EG", alpha3: "EGY" },
  { name: "El Salvador", alpha2: "SV", alpha3: "SLV" },
  { name: "Equatorial Guinea", alpha2: "GQ", alpha3: "GNQ" },
  { name: "Eritrea", alpha2: "ER", alpha3: "ERI" },
  { name: "Estonia", alpha2: "EE", alpha3: "EST" },
  { name: "Ethiopia", alpha2: "ET", alpha3: "ETH" },
  { name: "European Union", alpha2: "EU", alpha3: "" },
  { name: "Faroe Islands", alpha2: "FO", alpha3: "FRO" },
  { name: "Fiji", alpha2: "FJ", alpha3: "FJI" },
  { name: "Finland", alpha2: "FI", alpha3: "FIN" },
  { name: "France", alpha2: "FR", alpha3: "FRA" },
  { name: "French Guiana", alpha2: "GF", alpha3: "GUF" },
  { name: "French Polynesia", alpha2: "PF", alpha3: "PYF" },
  { name: "Gabon", alpha2: "GA", alpha3: "GAB" },
  { name: "Gambia", alpha2: "GM", alpha3: "GMB" },
  { name: "Georgia", alpha2: "GE", alpha3: "GEO" },
  { name: "Germany", alpha2: "DE", alpha3: "DEU" },
  { name: "Ghana", alpha2: "GH", alpha3: "GHA" },
  { name: "Greece", alpha2: "GR", alpha3: "GRC" },
  { name: "Greenland", alpha2: "GL", alpha3: "GRL" },
  { name: "Grenada", alpha2: "GD", alpha3: "GRD" },
  { name: "Guadeloupe", alpha2: "GP", alpha3: "GLP" },
  { name: "Guam", alpha2: "GU", alpha3: "GUM" },
  { name: "Guatemala", alpha2: "GT", alpha3: "GTM" },
  { name: "Guinea-Bissau", alpha2: "GW", alpha3: "GNB" },
  { name: "Haiti", alpha2: "HT", alpha3: "HTI" },
  { name: "Honduras", alpha2: "HN", alpha3: "HND" },
  { name: "Hungary", alpha2: "HU", alpha3: "HUN" },
  { name: "Iceland", alpha2: "IS", alpha3: "ISL" },
  { name: "India", alpha2: "IN", alpha3: "IND" },
  { name: "Indonesia", alpha2: "ID", alpha3: "IDN" },
  { name: "Iran (Islamic Republic of)", alpha2: "IR", alpha3: "IRN" },
  { name: "Iraq", alpha2: "IQ", alpha3: "IRQ" },
  { name: "Ireland", alpha2: "IE", alpha3: "IRL" },
  { name: "Israel", alpha2: "IL", alpha3: "ISR" },
  { name: "Italy", alpha2: "IT", alpha3: "ITA" },
  { name: "Japan", alpha2: "JP", alpha3: "JPN" },
  { name: "Jordan", alpha2: "JO", alpha3: "JOR" },
  { name: "Kazakhstan", alpha2: "KZ", alpha3: "KAZ" },
  { name: "Kenya", alpha2: "KE", alpha3: "KEN" },
  { name: "Kiribati", alpha2: "KI", alpha3: "KIR" },
  { name: "Korea", alpha2: "KP", alpha3: "PRK" },
  { name: "Korea", alpha2: "KR", alpha3: "KOR" },
  { name: "Kuwait", alpha2: "KW", alpha3: "KWT" },
  { name: "Kyrgyzstan", alpha2: "KG", alpha3: "KGZ" },
  { name: "Lao PDR", alpha2: "LA", alpha3: "LAO" },
  { name: "Latvia", alpha2: "LV", alpha3: "LVA" },
  { name: "Lebanon", alpha2: "LB", alpha3: "LBN" },
  { name: "Lesotho", alpha2: "LS", alpha3: "LSO" },
  { name: "Liberia", alpha2: "LR", alpha3: "LBR" },
  { name: "Libya", alpha2: "LY", alpha3: "LBY" },
  { name: "Liechtenstein", alpha2: "LI", alpha3: "LIE" },
  { name: "Lithuania", alpha2: "LT", alpha3: "LTU" },
  { name: "Luxembourg", alpha2: "LU", alpha3: "LUX" },
  { name: "Madagascar", alpha2: "MG", alpha3: "MDG" },
  { name: "Malawi", alpha2: "MW", alpha3: "MWI" },
  { name: "Malaysia", alpha2: "MY", alpha3: "MYS" },
  { name: "Maldives", alpha2: "MV", alpha3: "MDV" },
  { name: "Mali", alpha2: "ML", alpha3: "MLI" },
  { name: "Malta", alpha2: "MT", alpha3: "MLT" },
  { name: "Marshall Islands", alpha2: "MH", alpha3: "MHL" },
  { name: "Martinique", alpha2: "MQ", alpha3: "MTQ" },
  { name: "Mauritania", alpha2: "MR", alpha3: "MRT" },
  { name: "Mauritius", alpha2: "MU", alpha3: "MUS" },
  { name: "Mexico", alpha2: "MX", alpha3: "MEX" },
  { name: "Micronesia, Federated States of", alpha2: "FM", alpha3: "FSM" },
  { name: "Moldova", alpha2: "MD", alpha3: "MDA" },
  { name: "Monaco", alpha2: "MC", alpha3: "MCO" },
  { name: "Mongolia", alpha2: "MN", alpha3: "MNG" },
  { name: "Montenegro", alpha2: "ME", alpha3: "MNE" },
  { name: "Montserrat", alpha2: "MS", alpha3: "MSR" },
  { name: "Morocco", alpha2: "MA", alpha3: "MAR" },
  { name: "Mozambique", alpha2: "MZ", alpha3: "MOZ" },
  { name: "Myanmar", alpha2: "MM", alpha3: "MMR" },
  { name: "Namibia", alpha2: "NA", alpha3: "NAM" },
  { name: "Nauru", alpha2: "NR", alpha3: "NRU" },
  { name: "Nepal", alpha2: "NP", alpha3: "NPL" },
  { name: "Netherlands", alpha2: "NL", alpha3: "NLD" },
  { name: "Netherlands Antilles", alpha2: "AN", alpha3: "ANT" },
  { name: "New Caledonia", alpha2: "NC", alpha3: "NCL" },
  { name: "New Zealand", alpha2: "NZ", alpha3: "NZL" },
  { name: "Nicaragua", alpha2: "NI", alpha3: "NIC" },
  { name: "Niger", alpha2: "NE", alpha3: "NER" },
  { name: "Nigeria", alpha2: "NG", alpha3: "NGA" },
  { name: "Northern Mariana Islands", alpha2: "MP", alpha3: "MNP" },
  { name: "Norway", alpha2: "NO", alpha3: "NOR" },
  { name: "Oman", alpha2: "OM", alpha3: "OMN" },
  { name: "Pakistan", alpha2: "PK", alpha3: "PAK" },
  { name: "Palau", alpha2: "PW", alpha3: "PLW" },
  { name: "Palestinian Territory", alpha2: "PS", alpha3: "PSE" },
  { name: "Panama", alpha2: "PA", alpha3: "PAN" },
  { name: "Papua New Guinea", alpha2: "PG", alpha3: "PNG" },
  { name: "Paraguay", alpha2: "PY", alpha3: "PRY" },
  { name: "Peru", alpha2: "PE", alpha3: "PER" },
  { name: "Philippines", alpha2: "PH", alpha3: "PHL" },
  { name: "Pitcairn", alpha2: "PN", alpha3: "PCN" },
  { name: "Poland", alpha2: "PL", alpha3: "POL" },
  { name: "Portugal", alpha2: "PT", alpha3: "PRT" },
  { name: "Puerto Rico", alpha2: "PR", alpha3: "PRI" },
  { name: "Qatar", alpha2: "QA", alpha3: "QAT" },
  { name: "Réunion", alpha2: "RE", alpha3: "REU" },
  { name: "Romania", alpha2: "RO", alpha3: "ROU" },
  { name: "Russian Federation", alpha2: "RU", alpha3: "RUS" },
  { name: "Rwanda", alpha2: "RW", alpha3: "RWA" },
  { name: "Saint Kitts and Nevis", alpha2: "KN", alpha3: "KNA" },
  { name: "Saint Lucia", alpha2: "LC", alpha3: "LCA" },
  { name: "Saint Vincent and Grenadines", alpha2: "VC", alpha3: "VCT" },
  { name: "Samoa", alpha2: "WS", alpha3: "WSM" },
  { name: "San Marino", alpha2: "SM", alpha3: "SMR" },
  { name: "Sao Tome and Principe", alpha2: "ST", alpha3: "STP" },
  { name: "Saudi Arabia", alpha2: "SA", alpha3: "SAU" },
  { name: "Senegal", alpha2: "SN", alpha3: "SEN" },
  { name: "Serbia", alpha2: "RS", alpha3: "SRB" },
  { name: "Seychelles", alpha2: "SC", alpha3: "SYC" },
  { name: "Sierra Leone", alpha2: "SL", alpha3: "SLE" },
  { name: "Singapore", alpha2: "SG", alpha3: "SGP" },
  { name: "Slovakia", alpha2: "SK", alpha3: "SVK" },
  { name: "Slovenia", alpha2: "SI", alpha3: "SVN" },
  { name: "Solomon Islands", alpha2: "SB", alpha3: "SLB" },
  { name: "Somalia", alpha2: "SO", alpha3: "SOM" },
  { name: "South Africa", alpha2: "ZA", alpha3: "ZAF" },
  { name: "Spain", alpha2: "ES", alpha3: "ESP" },
  { name: "Sri Lanka", alpha2: "LK", alpha3: "LKA" },
  { name: "Sudan", alpha2: "SD", alpha3: "SDN" },
  { name: "Suriname", alpha2: "SR", alpha3: "SUR" },
  { name: "Swaziland", alpha2: "SZ", alpha3: "SWZ" },
  { name: "Sweden", alpha2: "SE", alpha3: "SWE" },
  { name: "Switzerland", alpha2: "CH", alpha3: "CHE" },
  { name: "Syrian Arab Republic", alpha2: "SY", alpha3: "SYR" },
  { name: "Taiwan", alpha2: "TW", alpha3: "TWN" },
  { name: "Tajikistan", alpha2: "TJ", alpha3: "TJK" },
  { name: "Tanzania", alpha2: "TZ", alpha3: "TZA" },
  { name: "Thailand", alpha2: "TH", alpha3: "THA" },
  { name: "Timor-Leste", alpha2: "TL", alpha3: "TLS" },
  { name: "Togo", alpha2: "TG", alpha3: "TGO" },
  { name: "Tonga", alpha2: "TO", alpha3: "TON" },
  { name: "Trinidad and Tobago", alpha2: "TT", alpha3: "TTO" },
  { name: "Tunisia", alpha2: "TN", alpha3: "TUN" },
  { name: "Turkey", alpha2: "TR", alpha3: "TUR" },
  { name: "Turkmenistan", alpha2: "TM", alpha3: "TKM" },
  { name: "Tuvalu", alpha2: "TV", alpha3: "TUV" },
  { name: "Uganda", alpha2: "UG", alpha3: "UGA" },
  { name: "Ukraine", alpha2: "UA", alpha3: "UKR" },
  { name: "United Arab Emirates", alpha2: "AE", alpha3: "ARE" },
  { name: "United Kingdom", alpha2: "GB", alpha3: "GBR" },
  { name: "United States of America", alpha2: "US", alpha3: "USA" },
  { name: "Uruguay", alpha2: "UY", alpha3: "URY" },
  { name: "Uzbekistan", alpha2: "UZ", alpha3: "UZB" },
  { name: "Vanuatu", alpha2: "VU", alpha3: "VUT" },
  { name: "Venezuela", alpha2: "VE", alpha3: "VEN" },
  { name: "Viet Nam", alpha2: "VN", alpha3: "VNM" },
  { name: "Virgin Islands, US", alpha2: "VI", alpha3: "VIR" },
  { name: "Yemen", alpha2: "YE", alpha3: "YEM" },
  { name: "Zambia", alpha2: "ZM", alpha3: "ZMB" },
  { name: "Zimbabwe", alpha2: "ZW", alpha3: "ZWE" },
];

export const EXPORT_TEMPLATE_KEYS = [
  {
    key: "paidAt",
    label: "결제일시",
  },
  {
    key: "orderedAt",
    label: "주문일시",
  },
  {
    key: "returnedAt",
    label: "환불일시",
  },
  {
    key: "type",
    label: "주문종류",
  },
  {
    key: "itemsName",
    label: "주문제품",
  },
  {
    key: "quantity",
    label: "수량",
  },
  {
    key: "status",
    label: "주문상태",
  },
  {
    label: "배송상태",
    key: "shippingStatus",
  },
  {
    key: "orderNumber",
    label: "주문번호",
  },
  {
    key: "orderNumberWithDate",
    label: "일자별주문번호",
  },
  {
    key: "location",
    label: "주문지점",
  },
  {
    label: "발송지점",
    key: "shippingLocation",
  },
  {
    key: "origin",
    label: "판매처",
  },
  {
    key: "orderAmount",
    label: "주문금액",
  },
  {
    key: "discountAmount",
    label: "할인금액",
  },
  {
    key: "creditAmount",
    label: "선불금사용액",
  },
  {
    key: "taxRefundAmount",
    label: "즉시환급액",
  },
  {
    key: "afterTaxRefundAmount",
    label: "시후환급액",
  },
  {
    key: "shippingFee",
    label: "배송비",
  },
  {
    key: "paidAmount",
    label: "결제금액",
  },
  {
    key: "tax",
    label: "부가세",
  },
  {
    key: "unpaidAmount",
    label: "미결제금액",
  },
  {
    key: "refundAmount",
    label: "환불금액",
  },
  {
    key: "customer",
    label: "고객",
  },
  {
    key: "receiverAddress",
    label: "배송주소",
  },
  {
    key: "itemNote",
    label: "주문제품노트",
  },
  {
    key: "receiverName",
    label: "수령인이름",
  },
  {
    key: "receiverPhone",
    label: "수령인번호",
  },
  {
    key: "shippingNote",
    label: "배송노트",
  },
  {
    key: "shippingCompany",
    label: "배송사",
  },
  {
    key: "trackingNumber",
    label: "송장번호",
  },
  {
    key: "privacyAgreedAt",
    label: "배송정보수집동의일시",
  },
  {
    key: "paymentMethod",
    label: "결제수단",
  },
  {
    key: "orderNote",
    label: "주문노트",
  },
  {
    key: "employee",
    label: "담당직원",
  },
  {
    key: "itemOrderNumber",
    label: "제품별주문번호",
  },
  {
    key: "prodName",
    label: "제품이름",
  },
  {
    key: "skuName",
    label: "하위제품이름",
  },
  {
    key: "model",
    label: "품목코드",
  },
  {
    key: "barcode",
    label: "바코드",
  },
];

export const TEMPLATE_KEYS_FOR_ITEM = [
  {
    key: "paidAt",
    label: "결제일시",
  },
  {
    key: "orderedAt",
    label: "주문일시",
  },
  {
    key: "returnedAt",
    label: "환불일시",
  },
  {
    key: "type",
    label: "주문종류",
  },
  {
    key: "quantity",
    label: "수량",
  },
  {
    key: "status",
    label: "주문상태",
  },
  {
    key: "orderNumber",
    label: "주문번호",
  },
  {
    key: "orderNumberWithDate",
    label: "일자별주문번호",
  },
  {
    key: "location",
    label: "주문지점",
  },
  {
    key: "origin",
    label: "판매처",
  },
  {
    key: "orderAmount",
    label: "주문금액",
  },
  {
    key: "discountAmount",
    label: "할인금액",
  },
  {
    key: "paidAmount",
    label: "결제금액",
  },
  {
    key: "refundAmount",
    label: "환불금액",
  },
  {
    key: "customer",
    label: "고객",
  },
  {
    key: "receiverAddress",
    label: "배송주소",
  },
  {
    label: "배송상태",
    key: "shippingStatus",
  },
  {
    key: "receiverName",
    label: "수령인이름",
  },
  {
    key: "receiverPhone",
    label: "수령인번호",
  },
  {
    key: "shippingNote",
    label: "배송노트",
  },
  {
    key: "shippingCompany",
    label: "배송사",
  },
  {
    key: "trackingNumber",
    label: "송장번호",
  },
  {
    key: "privacyAgreedAt",
    label: "배송정보수집동의일시",
  },
  {
    key: "orderNote",
    label: "주문노트",
  },
  {
    key: "itemNote",
    label: "주문제품노트",
  },
  {
    key: "employee",
    label: "담당직원",
  },
  {
    key: "itemOrderNumber",
    label: "제품별주문번호",
  },
  {
    key: "prodName",
    label: "제품이름",
  },
  {
    key: "skuName",
    label: "하위제품이름",
  },
  {
    key: "model",
    label: "품목코드",
  },
  {
    key: "barcode",
    label: "바코드",
  },
];

export const TEMPLATE_KEYS_FOR_ORDER = [
  {
    key: "paidAt",
    label: "결제일시",
  },
  {
    key: "orderedAt",
    label: "주문일시",
  },
  {
    key: "returnedAt",
    label: "환불일시",
  },
  {
    key: "type",
    label: "주문종류",
  },
  {
    key: "itemsName",
    label: "주문제품",
  },
  {
    key: "quantity",
    label: "수량",
  },
  {
    key: "status",
    label: "주문상태",
  },
  {
    label: "배송상태",
    key: "shippingStatus",
  },
  {
    key: "orderNumber",
    label: "주문번호",
  },
  {
    key: "orderNumberWithDate",
    label: "일자별주문번호",
  },
  {
    key: "location",
    label: "주문지점",
  },
  {
    key: "origin",
    label: "판매처",
  },
  {
    key: "orderAmount",
    label: "주문금액",
  },
  {
    key: "discountAmount",
    label: "할인금액",
  },
  {
    key: "creditAmount",
    label: "선불금사용액",
  },
  {
    key: "taxRefundAmount",
    label: "즉시환급액",
  },
  {
    key: "afterTaxRefundAmount",
    label: "시후환급액",
  },
  {
    key: "shippingFee",
    label: "배송비",
  },
  {
    key: "paidAmount",
    label: "결제금액",
  },
  {
    key: "tax",
    label: "부가세",
  },
  {
    key: "unpaidAmount",
    label: "미결제금액",
  },
  {
    key: "refundAmount",
    label: "환불금액",
  },
  {
    key: "customer",
    label: "고객",
  },
  {
    key: "receiverAddress",
    label: "배송주소",
  },
  {
    key: "receiverName",
    label: "수령인이름",
  },
  {
    key: "receiverPhone",
    label: "수령인번호",
  },
  {
    key: "shippingNote",
    label: "배송노트",
  },
  {
    key: "shippingCompany",
    label: "배송사",
  },
  {
    key: "trackingNumber",
    label: "송장번호",
  },
  {
    key: "privacyAgreedAt",
    label: "배송정보수집동의일시",
  },
  {
    key: "paymentMethod",
    label: "결제수단",
  },
  {
    key: "orderNote",
    label: "주문노트",
  },
  {
    key: "employee",
    label: "담당직원",
  },
];

export const TEMPLATES_BY_HEADERKEY = EXPORT_TEMPLATE_KEYS.reduce((obj, h) => {
  obj[h.key] = h;
  return obj;
}, {});
export const TEMPLATES_FOR_ORDER_BY_HEADERKEY = TEMPLATE_KEYS_FOR_ORDER.reduce(
  (obj, h) => {
    obj[h.key] = h;
    return obj;
  },
  {},
);
export const TEMPLATES_FOR_ITEM_BY_HEADERKEY = TEMPLATE_KEYS_FOR_ITEM.reduce(
  (obj, h) => {
    obj[h.key] = h;
    return obj;
  },
  {},
);

export const TIMELINE_LABEL_BY_KEY = {
  created: "주문생성",
  paid: "결제완료",
  exchangeOut: "교환출고",
  returned: "반품처리",
  exchangeIn: "교환반품",
  refunded: "환불처리",
  confirmed: "발주확인",
  shipped: "배송완료",
};

export const STOCK_HELP_GUIDE = {
  salesReport: (
    <div className="h5">
      입고수량: 설정한 기간동안의 입고수량
      <br />
      <br />
      재고: 해당 제품의 현 재고수량
      <br />
      <br />
      마지막입고일: 조회기간과 상관없이 해당 제품의 마지막 입고일
      <br />
      <br />
      마지막판매일: 조회기간과 상관없이 해당 제품의 마지막 판매일
    </div>
  ),
};

export const PRODUCT_HELP_GUIDE = {
  availableLocation: (
    <div className="h5">
      선택한 활성화 지점에서 판매가능한 제품 목록을 조회할 수 있습니다.
    </div>
  ),
};

export const LOCATION_FEE_STOREIDS = ["st_OGNjN2RkNjFhZGFlNmRlMTE0"];

const BASIC_FEATURES = [
  {
    label: "제품관리",
    unregistered: true,
    registered: true,
  },
  {
    label: "월 주문 수",
    unregistered: true,
    registered: true,
    unregisterHelperText: "(100건*)",
    registerHelperText: "(무제한)",
  },
  {
    label: "할인관리",
    unregistered: true,
    registered: true,
  },
  {
    label: "주문내역 관리",
    unregistered: true,
    registered: true,
  },
  {
    label: "기기연동",
    unregistered: true,
    registered: true,
  },
  {
    label: "재고입출내역 관리",
    unregistered: true,
    registered: true,
  },
  {
    label: "스마트폰 리포트",
    unregistered: true,
    registered: true,
  },
  {
    label: "스마트영수증 발송",
    unregistered: false,
    registered: true,
  },
  {
    label: "주문단계 관리",
    unregistered: true,
    registered: true,
  },
  {
    label: "직원관리",
    unregistered: false,
    registered: true,
  },
];

const DELIVERY_FEATURES = [
  {
    label: "배달의 민족",
    unregistered: false,
    registered: true,
  },
  {
    label: "쿠팡이츠",
    unregistered: false,
    registered: true,
  },
  {
    label: "요기요",
    unregistered: false,
    registered: true,
  },
];

const EXTRA_FEATURES = [
  {
    label: "키오스크 모드",
    unregistered: false,
    registered: true,
  },
  {
    label: "테이블오더 모드",
    unregistered: false,
    registered: true,
  },
  {
    label: "듀얼스크린 모드",
    unregistered: false,
    registered: true,
  },
  {
    label: "웨이팅 모드",
    unregistered: false,
    registered: true,
  },
  {
    label: "KDS",
    unregistered: false,
    registered: true,
  },
];

const CRM_FEATURES = [
  {
    label: "포인트적립 프로그램",
    unregistered: false,
    registered: true,
  },
  {
    label: "선불금 관리",
    unregistered: false,
    registered: true,
  },
  {
    label: "고객 통합조회",
    unregistered: false,
    registered: true,
  },
  {
    label: "주문수령 알림톡",
    unregistered: false,
    registered: true,
  },
  {
    label: "SMS/LMS/MMS",
    unregistered: false,
    registered: true,
  },
  {
    label: "카카오 알림톡 캠페인",
    unregistered: false,
    registered: true,
  },
  {
    label: "카카오 친구톡 캠페인",
    unregistered: false,
    registered: true,
  },
  {
    label: "다이렉트 메시지",
    unregistered: false,
    registered: true,
  },
  {
    label: "카카오채널 연동",
    unregistered: false,
    registered: true,
  },
  {
    label: "태그관리",
    unregistered: false,
    registered: true,
  },
];

const REPORT_FEATURES = [
  {
    label: "매출요약 리포트",
    unregistered: true,
    registered: true,
  },
  {
    label: "제품 리포트",
    unregistered: true,
    registered: true,
  },
  {
    label: "할인 리포트",
    unregistered: true,
    registered: true,
  },
  {
    label: "배달 리포트",
    unregistered: true,
    registered: true,
  },
  {
    label: "마감 리포트",
    unregistered: true,
    registered: true,
  },
  {
    label: "고객 리포트",
    unregistered: true,
    registered: true,
  },
  {
    label: "커스텀 리포트",
    unregistered: false,
    registered: true,
  },
  {
    label: "리포트 다운로드",
    unregistered: false,
    registered: true,
  },
];

export const PLAN_FEATURES = [
  { label: "기본제공기능", features: BASIC_FEATURES },
  { label: "배달앱 연동", features: DELIVERY_FEATURES },
  { label: "부가서비스", features: EXTRA_FEATURES },
  { label: "CRM", features: CRM_FEATURES },
  { label: "리포트", features: REPORT_FEATURES },
];

const RETAIL_BASIC_FEATURES = [
  {
    label: "제품관리",
    unregistered: true,
    registered: true,
  },
  {
    label: "할인관리",
    unregistered: true,
    registered: true,
  },
  {
    label: "주문내역 관리",
    unregistered: true,
    registered: true,
  },
  {
    label: "기기연동",
    unregistered: true,
    registered: true,
  },
  {
    label: "재고입출내역 관리",
    unregistered: true,
    registered: true,
  },
  {
    label: "스마트폰 리포트",
    unregistered: true,
    registered: true,
  },
  {
    label: "스마트영수증 발송",
    unregistered: false,
    registered: true,
  },
  {
    label: "직원관리",
    unregistered: false,
    registered: true,
  },
];

const RETAIL_ORDER_FEATURES = [
  {
    label: "즉시판매",
    unregistered: true,
    registered: true,
  },
  {
    label: "출고대기",
    unregistered: true,
    registered: true,
  },
  {
    label: "배송주문",
    unregistered: true,
    registered: true,
  },
  {
    label: "교환주문",
    unregistered: true,
    registered: true,
  },
];

const RETAIL_STOCK_FEATURES = [
  {
    label: "상품등록수",
    unregistered: true,
    registered: true,
    unregisterHelperText: "(제한없음)",
    registerHelperText: "(제한없음)",
  },
  {
    label: "월 재고트래픽",
    unregistered: true,
    registered: true,
    unregisterHelperText: "(100건)",
    registerHelperText: "(제한없음*)",
  },
  {
    label: "재고현황 조회",
    unregistered: true,
    registered: true,
  },
  {
    label: "지점/창고별 재고조회",
    unregistered: false,
    registered: true,
  },
  {
    label: "재고요청",
    unregistered: false,
    registered: true,
  },
  {
    label: "발주서 관리",
    unregistered: true,
    registered: true,
  },
  {
    label: "이동(RT) 관리",
    unregistered: false,
    registered: true,
  },
  {
    label: "재고히스토리 조회",
    unregistered: true,
    registered: true,
  },
  {
    label: "재고수불내역 조회",
    unregistered: false,
    registered: true,
  },
  {
    label: "재고변동내역 조회",
    unregistered: false,
    registered: true,
  },
  {
    label: "거래처 관리",
    unregistered: false,
    registered: true,
  },
  {
    label: "재고실사",
    unregistered: false,
    registered: true,
  },
  {
    label: "창고관리",
    unregistered: false,
    registered: true,
    registerHelperText: "(제한없음*)",
  },
  {
    label: "재고리스트 다운로드",
    unregistered: false,
    registered: true,
  },
];

const RETAIL_EXTRA_FEATURES = [
  {
    label: "스마트폰 재고모드",
    unregistered: false,
    registered: true,
  },
  {
    label: "리테일 키오스크",
    unregistered: false,
    registered: true,
  },
  {
    label: "듀얼스크린 모드",
    unregistered: false,
    registered: true,
  },
  {
    label: "웨이팅 모드",
    unregistered: false,
    registered: true,
  },
];

const RETAIL_CRM_FEATURES = [
  {
    label: "포인트적립 프로그램",
    unregistered: false,
    registered: true,
  },
  {
    label: "선불금 관리",
    unregistered: false,
    registered: true,
  },
  {
    label: "고객 통합조회",
    unregistered: false,
    registered: true,
  },
  {
    label: "SMS/LMS/MMS",
    unregistered: false,
    registered: true,
  },
  {
    label: "카카오 알림톡 캠페인",
    unregistered: false,
    registered: true,
  },
  {
    label: "카카오 친구톡 캠페인",
    unregistered: false,
    registered: true,
  },
  {
    label: "다이렉트 메시지",
    unregistered: false,
    registered: true,
  },
  {
    label: "카카오채널 연동",
    unregistered: false,
    registered: true,
  },
  {
    label: "태그관리",
    unregistered: false,
    registered: true,
  },
];

const RETAIL_REPORT_FEATURES = [
  {
    label: "매출요약 리포트",
    unregistered: true,
    registered: true,
  },
  {
    label: "제품 리포트",
    unregistered: true,
    registered: true,
  },
  {
    label: "재고자산 리포트",
    unregistered: true,
    registered: true,
  },
  {
    label: "할인 리포트",
    unregistered: true,
    registered: true,
  },
  {
    label: "환급 리포트",
    unregistered: false,
    registered: true,
  },
  {
    label: "마감 리포트",
    unregistered: true,
    registered: true,
  },
  {
    label: "고객 리포트",
    unregistered: true,
    registered: true,
  },
  {
    label: "커스텀 리포트",
    unregistered: false,
    registered: true,
  },
  {
    label: "리포트 다운로드",
    unregistered: false,
    registered: true,
  },
];

export const RETAIL_PLAN_FEATURES = [
  { label: "기본제공기능", features: RETAIL_BASIC_FEATURES },
  { label: "주문관리", features: RETAIL_ORDER_FEATURES },
  { label: "재고관리", features: RETAIL_STOCK_FEATURES },
  { label: "부가서비스", features: RETAIL_EXTRA_FEATURES },
  { label: "CRM", features: RETAIL_CRM_FEATURES },
  { label: "리포트", features: RETAIL_REPORT_FEATURES },
];

export const AGE_LABEL_BY_KEY = {
  group10s: "10대",
  group20s: "20대",
  group30s: "30대",
  group40s: "40대",
  group50s: "50대",
  over60s: "60대이상",
};

export const GENDER_LABEL_BY_KEY = {
  male: "남성",
  female: "여성",
};

export const REQUEST_TABLE_HEADER = [
  {
    key: "check",
    label: "선택",
    width: "5%",
    style: { textAlign: "center" },
  },
  {
    key: "number",
    label: "요청번호",
    width: "7%",
    style: { textAlign: "center" },
  },
  {
    key: "type",
    label: "종류",
    width: "7%",
    style: { textAlign: "center" },
  },
  {
    key: "location",
    label: "요청매장",
    width: "10%",
    style: { textAlign: "center" },
  },
  {
    key: "employee",
    label: "담당자",
    width: "9%",
    style: { textAlign: "center" },
  },
  {
    key: "status",
    label: "상태",
    width: "7%",
    style: { textAlign: "center" },
  },
  {
    key: "requestedAt",
    label: "요청일시",
    width: "11%",
    style: { textAlign: "center" },
  },
  {
    key: "confirmedAt",
    label: "확인일시",
    width: "11%",
    style: { textAlign: "center" },
  },
  {
    key: "shippedAt",
    label: "배송일시",
    width: "11%",
    style: { textAlign: "center" },
  },
  {
    key: "completedAt",
    label: "입고일시",
    width: "11%",
    style: { textAlign: "center" },
  },
  {
    key: "action",
    label: "더보기",
    width: "8%",
    style: { padding: "5px 10px" },
  },
];

export const REQUEST_TABLE_HEADER_AFTER_SHIPPING = [
  {
    key: "number",
    label: "요청번호",
    width: "7%",
    style: { textAlign: "center" },
  },
  {
    key: "type",
    label: "종류",
    width: "7%",
    style: { textAlign: "center" },
  },
  {
    key: "location",
    label: "요청매장",
    width: "10%",
    style: { textAlign: "center" },
  },
  {
    key: "fromLocation",
    label: "출고지점",
    width: "10%",
    style: { textAlign: "center" },
  },
  {
    key: "employee",
    label: "담당자",
    width: "9%",
    style: { textAlign: "center" },
  },
  {
    key: "status",
    label: "상태",
    width: "7%",
    style: { textAlign: "center" },
  },
  {
    key: "shippedAt",
    label: "배송일시",
    width: "11%",
    style: { textAlign: "center" },
  },
  {
    key: "completedAt",
    label: "입고일시",
    width: "11%",
    style: { textAlign: "center" },
  },
  {
    key: "trackingNumber",
    label: "송장번호",
    width: "9%",
    style: { textAlign: "center" },
  },
  {
    key: "shippingCompnay",
    label: "배송사",
    width: "9%",
    style: { textAlign: "center" },
  },
  {
    key: "action",
    label: "더보기",
    width: "8%",
    style: { padding: "5px 10px" },
  },
];

export const REQUEST_TABLE_HEADER_FOR_INSPECTION = [
  {
    key: "number",
    label: "요청번호",
    width: "7%",
    style: { textAlign: "center" },
  },
  {
    key: "type",
    label: "종류",
    width: "7%",
    style: { textAlign: "center" },
  },
  {
    key: "location",
    label: "요청매장",
    width: "10%",
    style: { textAlign: "center" },
  },
  {
    key: "employee",
    label: "담당자",
    width: "9%",
    style: { textAlign: "center" },
  },
  {
    key: "status",
    label: "상태",
    width: "7%",
    style: { textAlign: "center" },
  },
  {
    key: "expected",
    label: "출고수량",
    width: "11%",
    style: { textAlign: "center" },
  },
  {
    key: "actual",
    label: "입고수량",
    width: "11%",
    style: { textAlign: "center" },
  },
  {
    key: "trackingNumber",
    label: "송장번호",
    width: "11%",
    style: { textAlign: "center" },
  },
  {
    key: "shippingCompnay",
    label: "배송사",
    width: "11%",
    style: { textAlign: "center" },
  },
  {
    key: "action",
    label: "더보기",
    width: "8%",
    style: { padding: "5px 10px" },
  },
];

export const CREATING_TABLE_HEADER = [
  {
    key: "createdAt",
    label: "최초 생성",
    width: "7%",
    style: { textAlign: "center" },
  },
  {
    key: "updatedAt",
    label: "마지막 업데이트",
    width: "7%",
    style: { textAlign: "center" },
  },
  {
    key: "type",
    label: "종류",
    width: "7%",
    style: { textAlign: "center" },
  },
  {
    key: "location",
    label: "요청매장",
    width: "10%",
    style: { textAlign: "center" },
  },
  {
    key: "status",
    label: "상태",
    width: "7%",
    style: { textAlign: "center" },
  },
  {
    key: "itemLength",
    label: "총 제품수",
    width: "11%",
    style: { textAlign: "center" },
  },
  {
    key: "totalQuantity",
    label: "총 요청수량",
    width: "11%",
    style: { textAlign: "center" },
  },
  {
    key: "action",
    label: "더보기",
    width: "8%",
    style: { padding: "5px 10px" },
  },
];

export const RETURN_REQUEST_TABLE_HEADER = [
  {
    key: "check",
    label: "선택",
    width: "5%",
    style: { textAlign: "center" },
  },
  {
    key: "number",
    label: "요청번호",
    width: "7%",
    style: { textAlign: "center" },
  },
  {
    key: "type",
    label: "종류",
    width: "7%",
    style: { textAlign: "center" },
  },
  {
    key: "fromLocation",
    label: "반품매장",
    width: "10%",
    style: { textAlign: "center" },
  },
  {
    key: "employee",
    label: "담당자",
    width: "9%",
    style: { textAlign: "center" },
  },
  {
    key: "status",
    label: "상태",
    width: "7%",
    style: { textAlign: "center" },
  },
  {
    key: "requestedAt",
    label: "요청일시",
    width: "11%",
    style: { textAlign: "center" },
  },
  {
    key: "confirmedAt",
    label: "확인일시",
    width: "11%",
    style: { textAlign: "center" },
  },
  {
    key: "shippedAt",
    label: "배송일시",
    width: "11%",
    style: { textAlign: "center" },
  },
  {
    key: "completedAt",
    label: "입고일시",
    width: "11%",
    style: { textAlign: "center" },
  },
  {
    key: "action",
    label: "더보기",
    width: "8%",
    style: { padding: "5px 10px" },
  },
];

export const RETURN_REQUEST_TABLE_HEADER_AFTER_SHIPPING = [
  {
    key: "number",
    label: "요청번호",
    width: "7%",
    style: { textAlign: "center" },
  },
  {
    key: "type",
    label: "종류",
    width: "7%",
    style: { textAlign: "center" },
  },
  {
    key: "fromLocation",
    label: "반품매장",
    width: "10%",
    style: { textAlign: "center" },
  },
  {
    key: "toLocation",
    label: "입고지점",
    width: "10%",
    style: { textAlign: "center" },
  },
  {
    key: "employee",
    label: "담당자",
    width: "9%",
    style: { textAlign: "center" },
  },
  {
    key: "status",
    label: "상태",
    width: "7%",
    style: { textAlign: "center" },
  },
  {
    key: "shippedAt",
    label: "배송일시",
    width: "11%",
    style: { textAlign: "center" },
  },
  {
    key: "completedAt",
    label: "입고일시",
    width: "11%",
    style: { textAlign: "center" },
  },
  {
    key: "trackingNumber",
    label: "송장번호",
    width: "9%",
    style: { textAlign: "center" },
  },
  {
    key: "shippingCompnay",
    label: "배송사",
    width: "9%",
    style: { textAlign: "center" },
  },
  {
    key: "action",
    label: "더보기",
    width: "8%",
    style: { padding: "5px 10px" },
  },
];

export const RETURN_CREATING_TABLE_HEADER = [
  {
    key: "createdAt",
    label: "최초 생성",
    width: "7%",
    style: { textAlign: "center" },
  },
  {
    key: "updatedAt",
    label: "마지막 업데이트",
    width: "7%",
    style: { textAlign: "center" },
  },
  {
    key: "type",
    label: "종류",
    width: "7%",
    style: { textAlign: "center" },
  },
  {
    key: "fromLocation",
    label: "반품매장",
    width: "10%",
    style: { textAlign: "center" },
  },
  {
    key: "status",
    label: "상태",
    width: "7%",
    style: { textAlign: "center" },
  },
  {
    key: "itemLength",
    label: "총 제품수",
    width: "11%",
    style: { textAlign: "center" },
  },
  {
    key: "totalQuantity",
    label: "총 요청수량",
    width: "11%",
    style: { textAlign: "center" },
  },
  {
    key: "action",
    label: "더보기",
    width: "8%",
    style: { padding: "5px 10px" },
  },
];

export const CREATING_HEADERS_FOR_SINGLE = [
  {
    key: "check",
    label: "선택",
    style: { textAlign: "center", minWidth: "50px" },
  },
  {
    key: "prodName",
    label: "제품명",
    headerStyle: { minWidth: "340px" },
  },
  {
    key: "skuName",
    label: "옵션명",
    headerStyle: { minWidth: "80px" },
  },
  {
    key: "model",
    label: "품목코드",
    headerStyle: { textAlign: "center", minWidth: "180px" },
  },
  {
    key: "price",
    label: "가격",
    style: { textAlign: "center" },
  },
  {
    key: "requestQuantity",
    label: "요청수",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
  {
    key: "currentQuantity",
    label: "보유재고",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
  {
    key: "lastWeek",
    label: "지난7일",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
  {
    key: "lastMonth",
    label: "지난30일",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
];

export const SINGLE_REQUEST_HEADERS = [
  {
    key: "check",
    label: "선택",
    style: { textAlign: "center", minWidth: "50px" },
  },
  {
    key: "prodName",
    label: "제품명",
    headerStyle: { minWidth: "340px" },
  },
  {
    key: "skuName",
    label: "옵션명",
    headerStyle: { minWidth: "80px" },
  },
  {
    key: "model",
    label: "품목코드",
    headerStyle: { textAlign: "center", minWidth: "180px" },
  },
  {
    key: "price",
    label: "가격",
    style: { textAlign: "center" },
  },
  {
    key: "quantity",
    label: "재고수",
    style: { textAlign: "center", minWidth: "80px" },
  },
  {
    key: "requestQuantity",
    label: "요청수",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
  {
    key: "confirmQuantity",
    label: "출고수",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
  {
    key: "currentQuantity",
    label: "보유재고",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
  {
    key: "lastWeek",
    label: "지난7일",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
  {
    key: "lastMonth",
    label: "지난30일",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
];

export const SINGLE_REQUEST_SHIPPING_HEADERS = [
  {
    key: "prodName",
    label: "제품명",
    headerStyle: { minWidth: "340px" },
  },
  {
    key: "skuName",
    label: "옵션명",
    headerStyle: { minWidth: "80px" },
  },
  {
    key: "model",
    label: "품목코드",
    headerStyle: { textAlign: "center", minWidth: "180px" },
  },
  {
    key: "price",
    label: "가격",
    style: { textAlign: "center" },
  },
  {
    key: "requestQuantity",
    label: "요청수",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
  {
    key: "confirmQuantity",
    label: "출고수",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
  {
    key: "receivedQuantity",
    label: "입고수",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
];

export const SINGLE_REQUEST_INSTRUCTION_HEADERS = [
  {
    key: "check",
    label: "선택",
    style: { textAlign: "center", minWidth: "50px" },
  },
  {
    key: "prodName",
    label: "제품명",
    headerStyle: { minWidth: "340px" },
  },
  {
    key: "skuName",
    label: "옵션명",
    headerStyle: { minWidth: "80px" },
  },
  {
    key: "model",
    label: "품목코드",
    headerStyle: { textAlign: "center", minWidth: "180px" },
  },
  {
    key: "price",
    label: "가격",
    style: { textAlign: "center" },
  },
  {
    key: "fromLocation",
    label: "출고지점",
    style: { textAlign: "center", minWidth: "80px" },
  },
  {
    key: "quantity",
    label: "재고수",
    style: { textAlign: "center", minWidth: "80px" },
  },
  {
    key: "confirmQuantity",
    label: "출고수",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
];

export const RETURN_SINGLE_REQUEST_HEADERS = [
  {
    key: "check",
    label: "선택",
    style: { textAlign: "center", minWidth: "50px" },
  },
  {
    key: "prodName",
    label: "제품명",
    headerStyle: { minWidth: "340px" },
  },
  {
    key: "skuName",
    label: "옵션명",
    headerStyle: { minWidth: "80px" },
  },
  {
    key: "model",
    label: "품목코드",
    headerStyle: { textAlign: "center", minWidth: "180px" },
  },
  {
    key: "price",
    label: "가격",
    style: { textAlign: "center" },
  },
  {
    key: "currentQuantity",
    label: "보유재고",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
  {
    key: "requestQuantity",
    label: "요청수",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
  {
    key: "confirmQuantity",
    label: "반품수",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
  {
    key: "lastWeek",
    label: "지난7일",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
  {
    key: "lastMonth",
    label: "지난30일",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
];

export const RETURN_SINGLE_REQUEST_SHIPPING_HEADERS = [
  {
    key: "prodName",
    label: "제품명",
    headerStyle: { minWidth: "340px" },
  },
  {
    key: "skuName",
    label: "옵션명",
    headerStyle: { minWidth: "80px" },
  },
  {
    key: "model",
    label: "품목코드",
    headerStyle: { textAlign: "center", minWidth: "180px" },
  },
  {
    key: "price",
    label: "가격",
    style: { textAlign: "center" },
  },
  {
    key: "requestQuantity",
    label: "요청수",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
  {
    key: "confirmQuantity",
    label: "반품수",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
  {
    key: "receivedQuantity",
    label: "반품완료",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
];

export const RETURN_SINGLE_REQUEST_INSTRUCTION_HEADERS = [
  {
    key: "check",
    label: "선택",
    style: { textAlign: "center", minWidth: "50px" },
  },
  {
    key: "prodName",
    label: "제품명",
    headerStyle: { minWidth: "340px" },
  },
  {
    key: "skuName",
    label: "옵션명",
    headerStyle: { minWidth: "80px" },
  },
  {
    key: "model",
    label: "품목코드",
    headerStyle: { textAlign: "center", minWidth: "180px" },
  },
  {
    key: "price",
    label: "가격",
    style: { textAlign: "center" },
  },
  {
    key: "requestQuantity",
    label: "반품요청",
    style: { textAlign: "center", minWidth: "80px" },
  },
  {
    key: "confirmQuantity",
    label: "반품출고",
    style: { textAlign: "center", minWidth: "80px" },
  },
  {
    key: "receivedQuantity",
    label: "반품완료",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
];

export const MULTI_REQUEST_HEADERS = [
  {
    key: "check",
    label: "선택",
    style: { textAlign: "center", minWidth: "50px" },
  },
  {
    key: "prodName",
    label: "제품명",
    headerStyle: { width: "340px" },
  },
  {
    key: "skuName",
    label: "옵션명",
    headerStyle: { minWidth: "80px" },
  },
  {
    key: "model",
    label: "품목코드",
    headerStyle: { textAlign: "center", width: "180px" },
  },
  {
    key: "price",
    label: "가격",
    style: { textAlign: "center" },
  },
  {
    key: "quantity",
    label: "재고수",
    style: { textAlign: "center", minWidth: "80px" },
  },
];

export const MULTI_REQUEST_SHIPPING_HEADERS = [
  {
    key: "prodName",
    label: "제품명",
    headerStyle: { width: "340px" },
  },
  {
    key: "skuName",
    label: "옵션명",
    headerStyle: { minWidth: "80px" },
  },
  {
    key: "model",
    label: "품목코드",
    headerStyle: { textAlign: "center", width: "180px" },
  },
  {
    key: "price",
    label: "가격",
    style: { textAlign: "center" },
  },
];

export const MULTI_REQUEST_LOCATION_HEADERS = [
  {
    key: "requestQuantity",
    label: "요청수",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
  {
    key: "confirmQuantity",
    label: "출고수",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
  {
    key: "currentQuantity",
    label: "보유재고",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
  {
    key: "lastWeek",
    label: "지난7일",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
  {
    key: "lastMonth",
    label: "지난30일",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
];

export const MULTI_REQUEST_SHIPPING_LOCATION_HEADERS = [
  {
    key: "requestQuantity",
    label: "요청수",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
  {
    key: "confirmQuantity",
    label: "출고수",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
  {
    key: "receivedQuantity",
    label: "입고수",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
];

export const MULTI_REQUEST_INSTRUCTION_LOCATION_HEADERS = [
  {
    key: "fromLocation",
    label: "출고지점",
    style: { textAlign: "center" },
    headerStyle: { width: "120px" },
  },
  {
    key: "fromLocationQuantity",
    label: "재고수",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
  {
    key: "confirmQuantity",
    label: "출고수",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
];

export const RETURN_MULTI_REQUEST_HEADERS = [
  {
    key: "check",
    label: "선택",
    style: { textAlign: "center", minWidth: "50px" },
  },
  {
    key: "prodName",
    label: "제품명",
    headerStyle: { width: "340px" },
  },
  {
    key: "skuName",
    label: "옵션명",
    headerStyle: { minWidth: "80px" },
  },
  {
    key: "model",
    label: "품목코드",
    headerStyle: { textAlign: "center", width: "180px" },
  },
  {
    key: "price",
    label: "가격",
    style: { textAlign: "center" },
  },
  {
    key: "quantity",
    label: "재고수",
    style: { textAlign: "center", minWidth: "80px" },
  },
];

export const RETURN_MULTI_REQUEST_SHIPPING_HEADERS = [
  {
    key: "prodName",
    label: "제품명",
    headerStyle: { width: "340px" },
  },
  {
    key: "skuName",
    label: "옵션명",
    headerStyle: { minWidth: "80px" },
  },
  {
    key: "model",
    label: "품목코드",
    headerStyle: { textAlign: "center", width: "180px" },
  },
  {
    key: "price",
    label: "가격",
    style: { textAlign: "center" },
  },
];

export const RETURN_MULTI_REQUEST_LOCATION_HEADERS = [
  {
    key: "requestQuantity",
    label: "요청수",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
  {
    key: "confirmQuantity",
    label: "반품수",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
  {
    key: "currentQuantity",
    label: "보유재고",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
  {
    key: "lastWeek",
    label: "지난7일",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
  {
    key: "lastMonth",
    label: "지난30일",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
];

export const RETURN_MULTI_REQUEST_SHIPPING_LOCATION_HEADERS = [
  {
    key: "fromLocationQuantity",
    label: "재고수",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
  {
    key: "requestQuantity",
    label: "요청수",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
  {
    key: "confirmQuantity",
    label: "반품수",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
];

export const RETURN_MULTI_REQUEST_INSTRUCTION_LOCATION_HEADERS = [
  {
    key: "fromLocationQuantity",
    label: "재고수",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
  {
    key: "requestQuantity",
    label: "요청수",
    style: { textAlign: "center" },
    headerStyle: { width: "120px" },
  },
  {
    key: "confirmQuantity",
    label: "반품수",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
];

export const RETURN_MULTI_REQUEST_RESULT_LOCATION_HEADERS = [
  {
    key: "fromLocationQuantity",
    label: "재고수",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
  {
    key: "confirmQuantity",
    label: "반품수",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
  {
    key: "receivedQuantity",
    label: "입고수",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
];

export const RETURN_MULTI_REQUEST_RESULT_INSTRUCTION_LOCATION_HEADERS = [
  {
    key: "fromLocationQuantity",
    label: "재고수",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
  {
    key: "confirmQuantity",
    label: "반품수",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
  {
    key: "receivedQuantity",
    label: "입고수",
    style: { textAlign: "center" },
    headerStyle: { width: "80px" },
  },
];

export const DATE_RANGE_OPTIONS = [
  {
    label: "이전 1개월",
    value: "1month",
    direction: "prev",
  },
  {
    label: "이후 1개월",
    value: "1month",
    direction: "next",
  },
  {
    label: "이전 1주",
    value: "1week",
    direction: "prev",
  },
  {
    label: "이후 1주",
    value: "1week",
    direction: "next",
  },
];

export const CAFE24_GUIDE_PAGES = {
  "inventory-search":
    "https://growingco.notion.site/272802605a5f80e59bf5ff83e170622a",
  "coupon-guide":
    "https://growingco.notion.site/5aaefe2d2e184593b3b49857a512c52e",
};

export const BARCODE_PRESET_TEMPLATES = [
  {
    id: "preset_name_option_price_barcode",
    name: "제품명 + 가격 + 바코드",
    kind: "barcode",
    components: [
      {
        type: "text",
        format: "{{name}}",
        x: 6,
        y: 6,
        w: 88,
        h: 28,
        fontSize: 20,
        maxLines: 2,
        align: "center",
        bold: true,
      },
      {
        type: "text",
        format: "₩{{price}}",
        x: 6,
        y: 39,
        w: 88,
        h: 10,
        fontSize: 14,
        maxLines: 1,
        align: "center",
        bold: true,
        gapAfterPct: 5,
      },
      {
        type: "barcode",
        format: "{{barcode}}",
        x: 8,
        y: 54,
        w: 84,
        h: 48,
        height: 18,
        align: "center",
        showText: true,
      },
    ],
  },

  {
    id: "preset_price_barcode",
    name: "가격만 + 바코드",
    kind: "barcode",
    components: [
      {
        type: "text",
        format: "₩{{price}}",
        x: 6,
        y: 6,
        w: 88,
        h: 14,
        fontSize: 20,
        maxLines: 1,
        align: "center",
        bold: true,
        gapAfterPct: 5,
      },
      {
        type: "barcode",
        format: "{{barcode}}",
        x: 8,
        y: 25,
        w: 84,
        h: 60,
        height: 18,
        align: "center",
        showText: true,
      },
    ],
  },

  {
    id: "preset_price_name_option_barcode",
    name: "가격정보 + 제품정보 + 바코드",
    kind: "barcode",
    components: [
      {
        type: "text",
        format: "₩{{price}}",
        x: 6,
        y: 6,
        w: 88,
        h: 14,
        fontSize: 20,
        maxLines: 1,
        align: "center",
        bold: true,
      },
      {
        type: "text",
        format: "{{name}}",
        x: 6,
        y: 25,
        w: 88,
        h: 20,
        fontSize: 14,
        maxLines: 2,
        align: "center",
        bold: false,
      },
      {
        type: "text",
        format: "{{skuName}}",
        x: 6,
        y: 50,
        w: 88,
        h: 10,
        fontSize: 14,
        maxLines: 1,
        align: "center",
        bold: false,
        gapAfterPct: 5,
      },
      {
        type: "barcode",
        format: "{{barcode}}",
        x: 8,
        y: 65,
        w: 84,
        h: 44,
        height: 18,
        align: "center",
        showText: true,
      },
    ],
  },

  {
    id: "preset_name_option_barcode",
    name: "제품명 + 옵션 + 바코드",
    kind: "barcode",
    components: [
      {
        type: "text",
        format: "{{name}}",
        x: 6,
        y: 6,
        w: 88,
        h: 14,
        fontSize: 20,
        maxLines: 1,
        align: "center",
        bold: true,
      },
      {
        type: "text",
        format: "{{skuName}}",
        x: 6,
        y: 25,
        w: 88,
        h: 14,
        fontSize: 20,
        maxLines: 1,
        align: "center",
        bold: false,
        gapAfterPct: 5,
      },
      {
        type: "barcode",
        format: "{{barcode}}",
        x: 8,
        y: 44,
        w: 84,
        h: 58,
        height: 18,
        align: "center",
        showText: true,
      },
    ],
  },
  {
    id: "preset_center_name_price_barcode",
    name: "중앙 정렬 + 제품명/가격 + 바코드",
    kind: "barcode",
    components: [
      {
        type: "text",
        format: "{{name}}",
        x: 6,
        y: 20,
        w: 88,
        h: 12,
        fontSize: 16,
        maxLines: 1,
        align: "center",
        bold: true,
      },
      {
        type: "text",
        format: "₩{{price}}",
        x: 6,
        y: 35,
        w: 88,
        h: 10,
        fontSize: 14,
        maxLines: 1,
        align: "center",
        bold: false,
        gapAfterPct: 5,
      },
      {
        type: "barcode",
        format: "{{barcode}}",
        x: 8,
        y: 50,
        w: 84,
        h: 40,
        height: 18,
        align: "center",
        showText: true,
      },
    ],
  },
  {
    id: "preset_center_name_sku_price_barcode",
    name: "중앙 정렬 + 제품명/옵션/가격 + 바코드",
    kind: "barcode",
    components: [
      {
        type: "text",
        format: "{{name}}",
        x: 6,
        y: 16,
        w: 88,
        h: 12,
        fontSize: 14,
        maxLines: 1,
        align: "center",
        bold: true,
      },
      {
        type: "text",
        format: "{{skuName}}",
        x: 6,
        y: 30,
        w: 88,
        h: 10,
        fontSize: 13,
        maxLines: 1,
        align: "center",
        bold: false,
      },
      {
        type: "text",
        format: "₩{{price}}",
        x: 6,
        y: 43,
        w: 88,
        h: 10,
        fontSize: 13,
        maxLines: 1,
        align: "center",
        bold: false,
      },
      {
        type: "barcode",
        format: "{{barcode}}",
        x: 8,
        y: 56,
        w: 84,
        h: 38,
        height: 18,
        align: "center",
        showText: true,
      },
    ],
  },

  // ------------------------
  // QR
  // ------------------------
  {
    id: "preset_qr_center_only",
    name: "QR 단독(가운데)",
    kind: "qrcode",
    components: [
      {
        type: "qrcode",
        format: "{{qrcode}}",
        x: 25,
        y: 20,
        w: 50,
        h: 50,
        align: "center",
      },
    ],
  },

  {
    id: "preset_qr_topleft_name20",
    name: "QR 좌측 + 제품명",
    kind: "qrcode",
    components: [
      {
        type: "qrcode",
        format: "{{qrcode}}",
        x: 3,
        y: 8,
        w: 30,
        h: 30,
        align: "topLeft",
      },
      {
        type: "text",
        format: "{{name}}",
        x: 37, // 3 + 30 + 4
        y: 8,
        w: 60, // 100 - 37 - 3
        h: 28, // 20px * 2줄
        fontSize: 20,
        maxLines: 2,
        align: "left",
        bold: true,
      },
    ],
  },

  {
    id: "preset_qr_topleft_name20_sku16",
    name: "QR 좌측 + 제품명 + 옵션(16)",
    kind: "qrcode",
    components: [
      {
        type: "qrcode",
        x: 3,
        y: 8,
        w: 30,
        h: 30,
        align: "topLeft",
        format: "{{qrcode}}",
      },
      {
        type: "text",
        x: 37,
        y: 8,
        w: 60,
        h: 28,
        fontSize: 20,
        maxLines: 2,
        align: "left",
        bold: true,
        format: "{{name}}",
        gapAfterPct: 5,
      },
      {
        type: "text",
        x: 37,
        y: 41,
        w: 60,
        h: 12,
        fontSize: 16,
        maxLines: 1,
        align: "left",
        bold: false,
        format: "{{skuName}}",
      },
    ],
  },

  {
    id: "preset_qr_topleft_name20_sku14_price14",
    name: "QR 좌측 + 제품명 + 옵션(14) + 가격(14)",
    kind: "qrcode",
    components: [
      {
        type: "qrcode",
        x: 3,
        y: 8,
        w: 30,
        h: 30,
        align: "topLeft",
        format: "{{qrcode}}",
      },
      {
        type: "text",
        x: 37,
        y: 8,
        w: 60,
        h: 28,
        fontSize: 20,
        maxLines: 2,
        align: "left",
        bold: true,
        format: "{{name}}",
        gapAfterPct: 5,
      },
      {
        type: "text",
        x: 37,
        y: 41,
        w: 60,
        h: 10,
        fontSize: 14,
        maxLines: 1,
        align: "left",
        bold: false,
        format: "{{skuName}}",
        gapAfterPct: 5,
      },
      {
        type: "text",
        x: 37,
        y: 56,
        w: 60,
        h: 10,
        fontSize: 14,
        maxLines: 1,
        align: "left",
        bold: true,
        format: "₩{{price}}",
      },
    ],
  },

  {
    id: "preset_qr_topcenter_name20",
    name: "QR 상단(가운데) + 제품명",
    kind: "qrcode",
    components: [
      {
        type: "qrcode",
        x: 35,
        y: 6,
        w: 30,
        h: 30,
        align: "topCenter",
        format: "{{qrcode}}",
        gapAfterPct: 5,
      },
      {
        type: "text",
        x: 6,
        y: 41,
        w: 88,
        h: 28,
        fontSize: 20,
        maxLines: 2,
        align: "center",
        bold: true,
        format: "{{name}}",
      },
    ],
  },

  {
    id: "preset_qr_topcenter_name20_price16",
    name: "QR 상단(가운데) + 제품명 + 가격(16)",
    kind: "qrcode",
    components: [
      {
        type: "qrcode",
        x: 35,
        y: 6,
        w: 30,
        h: 30,
        align: "topCenter",
        format: "{{qrcode}}",
        gapAfterPct: 5,
      },
      {
        type: "text",
        x: 6,
        y: 41,
        w: 88,
        h: 28,
        fontSize: 20,
        maxLines: 2,
        align: "center",
        bold: true,
        format: "{{name}}",
        gapAfterPct: 5,
      },
      {
        type: "text",
        x: 6,
        y: 74,
        w: 88,
        h: 12,
        fontSize: 16,
        maxLines: 1,
        align: "center",
        bold: true,
        format: "₩{{price}}",
      },
    ],
  },

  {
    id: "preset_qr_topcenter_name20_sku14_price14",
    name: "QR 상단(가운데) + 제품명 + 옵션(14) + 가격(14)",
    kind: "qrcode",
    components: [
      {
        type: "qrcode",
        x: 35,
        y: 6,
        w: 30,
        h: 30,
        align: "topCenter",
        format: "{{qrcode}}",
        gapAfterPct: 5,
      },
      {
        type: "text",
        x: 6,
        y: 41,
        w: 88,
        h: 28,
        fontSize: 20,
        maxLines: 2,
        align: "center",
        bold: true,
        format: "{{name}}",
        gapAfterPct: 5,
      },
      {
        type: "text",
        x: 6,
        y: 74,
        w: 88,
        h: 10,
        fontSize: 14,
        maxLines: 1,
        align: "center",
        bold: false,
        format: "{{skuName}}",
        gapAfterPct: 5,
      },
      {
        type: "text",
        x: 6,
        y: 89,
        w: 88,
        h: 10,
        fontSize: 14,
        maxLines: 1,
        align: "center",
        bold: true,
        format: "₩{{price}}",
      },
    ],
  },

  {
    id: "preset_qr_topright_name20",
    name: "QR 우측 + 제품명",
    kind: "qrcode",
    components: [
      {
        type: "qrcode",
        format: "{{qrcode}}",
        x: 67,
        y: 8,
        w: 30,
        h: 30,
        align: "topRight",
      },
      {
        type: "text",
        format: "{{name}}",
        x: 3,
        y: 8,
        w: 60,
        h: 28,
        fontSize: 20,
        maxLines: 2,
        align: "left",
        bold: true,
        gapAfterPct: 5,
      },
    ],
  },

  {
    id: "preset_qr_topright_name20_price16",
    name: "QR 우측 + 제품명 + 가격(16)",
    kind: "qrcode",
    components: [
      {
        type: "qrcode",
        format: "{{qrcode}}",
        x: 67,
        y: 8,
        w: 30,
        h: 30,
        align: "topRight",
      },
      {
        type: "text",
        format: "{{name}}",
        x: 3,
        y: 8,
        w: 60,
        h: 28,
        fontSize: 20,
        maxLines: 2,
        align: "left",
        bold: true,
        gapAfterPct: 5,
      },
      {
        type: "text",
        format: "₩{{price}}",
        x: 3,
        y: 37, // 8 + 28 + 1
        w: 60,
        h: 12,
        fontSize: 16,
        maxLines: 1, // ✅ 가격 1줄 고정
        align: "left",
        bold: true,
      },
    ],
  },
  {
    id: "preset_qr_topright_name20_sku14_price14",
    name: "QR 우측 + 제품명 + 옵션(14) + 가격(14)",
    kind: "qrcode",
    components: [
      {
        type: "qrcode",
        format: "{{qrcode}}",
        x: 67,
        y: 8,
        w: 30,
        h: 30,
        align: "topRight",
      },
      {
        type: "text",
        format: "{{name}}",
        x: 3,
        y: 8,
        w: 60,
        h: 28,
        fontSize: 20,
        maxLines: 2,
        align: "left",
        bold: true,
      },
      {
        type: "text",
        format: "{{skuName}}",
        x: 3,
        y: 37, // 8 + 28 + 1
        w: 60,
        h: 10,
        fontSize: 14,
        maxLines: 1,
        align: "left",
        bold: false,
        gapAfterPct: 5,
      },
      {
        type: "text",
        format: "₩{{price}}",
        x: 3,
        y: 48, // 37 + 10 + 1
        w: 60,
        h: 10,
        fontSize: 14,
        maxLines: 1,
        align: "left",
        bold: true,
      },
    ],
  },
  {
    id: "preset_qr_middle_center_name_price",
    name: "QR 중앙 + 제품명/가격",
    kind: "qrcode",
    components: [
      {
        type: "qrcode",
        format: "{{qrcode}}",
        x: 35,
        y: 28,
        w: 30,
        h: 30,
        align: "center",
      },
      {
        type: "text",
        format: "{{name}}",
        x: 6,
        y: 62,
        w: 88,
        h: 10,
        fontSize: 14,
        maxLines: 1,
        align: "center",
        bold: true,
        gapAfterPct: 5,
      },
      {
        type: "text",
        format: "₩{{price}}",
        x: 6,
        y: 74,
        w: 88,
        h: 10,
        fontSize: 14,
        maxLines: 1,
        align: "center",
        bold: false,
      },
    ],
  },
  {
    id: "preset_qr_middle_center_name_sku_price",
    name: "QR 중앙 + 제품명/옵션/가격",
    kind: "qrcode",
    components: [
      {
        type: "qrcode",
        format: "{{qrcode}}",
        x: 35,
        y: 18,
        w: 30,
        h: 30,
        align: "center",
      },
      {
        type: "text",
        format: "{{name}}",
        x: 6,
        y: 52,
        w: 88,
        h: 10,
        fontSize: 14,
        maxLines: 1,
        align: "center",
        bold: true,
      },
      {
        type: "text",
        format: "{{skuName}}",
        x: 6,
        y: 64,
        w: 88,
        h: 10,
        fontSize: 13,
        maxLines: 1,
        align: "center",
        bold: false,
      },
      {
        type: "text",
        format: "₩{{price}}",
        x: 6,
        y: 76,
        w: 88,
        h: 10,
        fontSize: 13,
        maxLines: 1,
        align: "center",
        bold: false,
      },
    ],
  },
  {
    id: "preset_text_center_absolute",
    name: "중앙 정렬 (제품명·상세·가격)",
    kind: "text",
    components: [
      {
        type: "text",
        format: "{{name}}",
        x: 0,
        y: 20,
        w: 100,
        h: 22,
        fontSize: 20,
        maxLines: 2,
        align: "center",
        bold: true,
      },
      {
        type: "text",
        format: "{{skuName}}",
        x: 0,
        y: 45,
        w: 100,
        h: 10,
        fontSize: 14,
        maxLines: 1,
        align: "center",
        bold: false,
      },
      {
        type: "text",
        format: "{{model}}",
        x: 0,
        y: 58,
        w: 100,
        h: 10,
        fontSize: 14,
        maxLines: 1,
        align: "center",
        bold: false,
      },
      {
        type: "text",
        format: "₩{{price}}",
        x: 0,
        y: 71,
        w: 100,
        h: 12,
        fontSize: 16,
        maxLines: 1,
        align: "center",
        bold: true,
      },
    ],
  },
  {
    id: "preset_text_center_name_sku_price",
    name: "중앙형 · 제품명 / 옵션 / 가격",
    kind: "text",
    components: [
      {
        type: "text",
        format: "{{name}}",
        x: 6,
        y: 10,
        w: 88,
        h: 20,
        fontSize: 20,
        maxLines: 2,
        align: "center",
        bold: true,
      },
      {
        type: "text",
        format: "{{skuName}}",
        x: 6,
        y: 34, // 2줄 정도 간격
        w: 88,
        h: 10,
        fontSize: 14,
        maxLines: 1,
        align: "center",
        bold: false,
      },
      {
        type: "text",
        format: "₩{{price}}",
        x: 6,
        y: 46,
        w: 88,
        h: 10,
        fontSize: 14,
        maxLines: 1,
        align: "center",
        bold: false,
      },
    ],
  },
  {
    id: "preset_text_left_name_sku_right_price",
    name: "좌측 제품명·옵션 / 우측 가격",
    kind: "text",
    components: [
      {
        type: "text",
        format: "{{name}}-{{skuName}}",
        x: 6,
        y: 12,
        w: 70,
        h: 20,
        fontSize: 20,
        maxLines: 2,
        align: "left",
        bold: true,
      },
      {
        type: "text",
        format: "₩{{price}}",
        x: 60,
        y: 40,
        w: 34,
        h: 14,
        fontSize: 20,
        maxLines: 1,
        align: "right",
        bold: true,
      },
    ],
  },
  {
    id: "preset_text_bottom_right_name_price",
    name: "하단 우측 · 제품명 / 가격",
    kind: "text",
    components: [
      {
        type: "text",
        format: "{{name}}",
        x: 40,
        y: 32, // 위 공간 절반 비움
        w: 54,
        h: 12,
        fontSize: 14,
        maxLines: 1,
        align: "right",
        bold: true,
      },
      {
        type: "text",
        format: "₩{{price}}",
        x: 40,
        y: 46,
        w: 54,
        h: 10,
        fontSize: 14,
        maxLines: 1,
        align: "right",
        bold: false,
      },
    ],
  },
  {
    id: "preset_text_left_name_right_details",
    name: "좌측 제품명 / 우측 옵션·SKU·가격",
    kind: "text",
    components: [
      {
        type: "text",
        format: "{{name}}",
        x: 6,
        y: 10,
        w: 44,
        h: 22,
        fontSize: 20,
        maxLines: 2,
        align: "left",
        bold: true,
      },
      {
        type: "text",
        format: "{{skuName}}",
        x: 52,
        y: 10,
        w: 42,
        h: 10,
        fontSize: 14,
        maxLines: 1,
        align: "right",
        bold: false,
      },
      {
        type: "text",
        format: "{{model}}",
        x: 52,
        y: 22,
        w: 42,
        h: 10,
        fontSize: 14,
        maxLines: 1,
        align: "right",
        bold: false,
      },
      {
        type: "text",
        format: "₩{{price}}",
        x: 52,
        y: 36,
        w: 42,
        h: 10,
        fontSize: 14,
        maxLines: 1,
        align: "right",
        bold: false,
      },
    ],
  },
];

export const CONDITION_NOTIFY_OPTIONS = [
  {
    value: "expiredPoint",
    label: "포인트 만료 예정시",
    description:
      "· 고객의 보유 포인트 사용기한 만료일 기준 15일 전 13시 30분부터 자동 발송",
    channels: ["alimtalk", "sms"],
  },
  {
    value: "creditRecharge",
    label: "선불금 충전시",
    description: "· 고객이 매장에서 선불금 충전시 자동 발송",
    channels: ["alimtalk", "sms"],
  },
  {
    value: "creditUse",
    label: "선불금 사용시",
    description: "· 고객이 매장에서 선불금 사용시 자동 발송",
    channels: ["alimtalk", "sms"],
  },
  {
    value: "firstVisit",
    label: "첫 방문시",
    description: "· 고객이 매장에 방문하여 첫 주문을 결제할시 자동 발송",
    channels: ["sms"],
  },
];

export const CHANNEL_LABEL_BY_KEY = {
  alimtalk: "알림톡",
  sms: "문자메시지",
};

export const CONDITION_RECOMMEND_OPTIONS = [
  {
    label: "우리 매장에 10번 이상 주문하신 고객에게 자동 발송",
    conditions: [
      {
        key: "visitCount",
        object: "order",
        operations: [
          {
            operation: "gte",
            type: "number",
            value: 10,
          },
        ],
      },
    ],
  },
  {
    label: "*** 쿠폰 사용한 고객에게 자동 발송",
    conditions: [
      {
        key: "couponId",
        object: "order",
        operations: [
          {
            operation: "eq",
            type: "string",
            value: null,
          },
        ],
      },
    ],
  },
  {
    label: "누적 100,000원 이상 구매한 고객에게 자동 발송",
    conditions: [
      {
        key: "orderAmount",
        object: "order",
        operations: [
          {
            operation: "gte",
            type: "number",
            value: 100000,
          },
        ],
      },
    ],
  },
  {
    label: "*** 제품을 구매한 고객에게 자동 발송",
    conditions: [
      {
        key: "productId",
        object: "product",
        operations: [
          {
            operation: "eq",
            type: "string",
            value: null,
          },
        ],
      },
    ],
  },
  {
    label: "10회 이상 주문 그리고 30만원 이상 결제하신 고객에게 자동 발송",
    conditions: [
      {
        key: "orderAmount",
        object: "order",
        operations: [
          {
            operation: "gte",
            type: "number",
            value: 300000,
          },
        ],
      },
      {
        key: "visitCount",
        object: "order",
        operations: [
          {
            operation: "gte",
            type: "number",
            value: 10,
          },
        ],
      },
    ],
  },
];

export const AUTO_CAMPAIGN_TEXT_TEMPLATES_BY_CONDITION = {
  others: [
    {
      key: "expiredCoupon",
      title: "[보유 쿠폰 만료 안내]",
      buttonTitle: "쿠폰 확인하기",
      buttonLink: "#{landing_url_button}",
      message:
        "안녕하세요!\n\n#{STORE_NAME}에서 보유하신 쿠폰 중, 곧 유효기간이 만료되는 쿠폰이 있어 안내해 드립니다. \n만료일 이후에는 자동 소멸되어 사용이 불가하오니 참고 부탁드립니다.\n\n[만료 예정 쿠폰]\n- 기간안내 : #{COUPON_DATE}\n- 쿠폰명 : #{COUPON_NAME}\n- 할인 세부정보 : #{DISCOUNT_INFO}\n- 사용방법: #{USE_GUIDE}\n\n",
    },
    {
      key: "others-coupon",
      title: "#{STORE_NAME} 쿠폰 발송",

      message:
        "안녕하세요, #{NAME}님!\n\n#{STORE_NAME}을 사랑해주시는 고객님을 위한 깜짝 쿠폰이 발송되었습니다 😆\n\n- 쿠폰 이름 : #{COUPON_NAME}\n- 할인금액 : #{DISCOUNT_INFO}\n- 사용기한 : #{COUPON_DATE}\n\n발급된 쿠폰의 자세한 사항은 #{SITE}을 통해 확인 부탁드립니다.\n\n문의전화 : #{STORE_NUMBER}",
    },
    {
      key: "others-season",
      title: "✨S/S Season NEW ARRIVALS✨",
      message:
        "#{STORE_NAME}이 이번 시즌 새롭게 제안하는 아이템을 가장 먼저 확인해보세요!\n\n문의전화 : #{STORE_NUMBER}",
    },
  ],
  expiredPoint: [
    {
      key: "expiredPoint",
      title: "#{STORE_NAME} 적립금 소멸 안내",
      ads: false,
      message:
        "#{NAME}님,\n#{STORE_NAME}에서 보유하고 계신 적립금이 소멸될 예정입니다.\n\n기한 내 미사용시 해당 적립금은 자동 소멸되오니 이용에 참고 부탁드립니다.\n\n- 현재 보유 적립금 : #{POINT}P\n- 소멸 예정 적립금 : #{EXPIRED_POINT}P\n- 소멸 후 예상 잔여 적립금 : #{TOTAL_POINT}P\n- 사용처 : #{STORE_NAME}\n\n문의하기 : #{STORE_NUMBER}",
    },
  ],
  creditRecharge: [
    {
      key: "creditRecharge",
      title: "[선불금 충전 완료 안내]",
      ads: false,
      message:
        "안녕하세요,\n\n요청하신 선불금 충전이 정상적으로 완료되었습니다.\n\n[충전 내역]\n- 매장명: #{STORE_NAME}\n- 충전 일시 : #{CHARGE_DATE}\n- 충전 금액 : #{CHARGE_AMOUNT}원\n- 충전 후 잔액 : #{BALANCE}원\n\n문의하기 : #{STORE_NUMBER}",
    },
  ],
  creditUse: [
    {
      key: "creditUse",
      title: "[선불금 사용 안내]",
      ads: false,
      message:
        "#{STORE_NAME}을 방문해 주셔서 감사합니다.\n사용하신 선불금 결제 내역을 안내해 드립니다.\n\n[선불금 사용 내역]\n- 매장명: #{STORE_NAME}\n- 사용 일시 : #{USE_DATE}\n- 사용 금액 : #{USE_AMOUNT}원\n- 사용 후 잔액 : #{BALANCE}원\n\n사용 내역에 이상이 있을 경우 아래 연락처로 문의 부탁드립니다.\n\n문의하기 : #{STORE_NUMBER}",
    },
  ],
  firstVisit: [
    {
      key: "firstVisit",
      title: "첫 방문을 감사드립니다.",
      message:
        "안녕하세요, #{NAME}님!\n\n#{STORE_NAME}의 방문을 환영합니다!\n\n#{STORE_NAME}의 첫 구매에 감사드리며, 다음 방문시 사용하실 수 있는 쿠폰을 제공드립니다.\n- 사용기간 : #{COUPON_DATE}\n- 쿠폰 이름 : #{COUPON_NAME}\n\n- 할인 세부정보 : #{DISCOUNT_INFO}\n\n기간내에 쿠폰을 사용하지 않을 경우 쿠폰은 자동 소멸되며, 이후 재발급이 불가능 합니다.",
    },
  ],
};

export const AUTO_CAMPAIGN_PERSONAL_VARIABLES = [
  {
    value: "#{CUSTOMER_NAME}",
    text: "고객 이름",
    description: "고객 이름이 있을시 노출되며, 없을시 공란으로 표시",
  },
];

export const AUTO_CAMPAIGN_TEMPLATE_VARIABLES = [
  {
    key: "NAME",
    text: "NAME",
    description:
      "고객의 이름이 입력됩니다. 이름이 없을시 '고객'으로 대체됩니다.",
  },
  {
    key: "STORE_NAME",
    text: "STORE_NAME",
    description: "매장 이름이 입력됩니다.",
  },
  {
    key: "BRAND_NAME",
    text: "BRAND_NAME",
    description: "본사 이름이 입력됩니다.",
  },
  {
    key: "POINT",
    text: "POINT",
    description: "현재 보유 포인트가 입력됩니다.",
  },
  {
    key: "EXPIRED_POINT",
    text: "EXPIRED_POINT",
    description: "소멸 예정 포인트가 입력됩니다.",
  },
  {
    key: "TOTAL_POINT",
    text: "TOTAL_POINT",
    description: "잔여 포인트가 입력됩니다.",
  },
  {
    key: "EXPIRY_DATE",
    text: "EXPIRY_DATE",
    description: "유효기간이 입력됩니다.",
  },
  {
    key: "STORE_NUMBER",
    text: "STORE_NUMBER",
    description: "매장 전화번호가 입력됩니다.",
  },
  {
    key: "COUPON_ID",
    text: "COUPON_ID",
    description:
      "쿠폰을 발급한 브랜드 혹은 매장이름을 입력해 주세요.(16자 제한)",
  },
  {
    key: "CHARGE_DATE",
    text: "CHARGE_DATE",
    description: "선불금 충전일시가 입력됩니다.",
  },
  {
    key: "CHARGE_AMOUNT",
    text: "CHARGE_AMOUNT",
    description: "선불금 충전 금액이 입력됩니다.",
  },
  {
    key: "BALANCE",
    text: "BALANCE",
    description: "선불금 충전/사용 후 잔액이 입력됩니다.",
  },
  {
    key: "USE_DATE",
    text: "USE_DATE",
    description: "선불금 사용일시가 입력됩니다.",
  },
  {
    key: "USE_AMOUNT",
    text: "USE_AMOUNT",
    description: "선불금 사용금액이 입력됩니다.",
  },
  {
    key: "COUPON_DATE",
    text: "COUPON_DATE",
    description: "쿠폰 유효기간이 입력됩니다.",
  },
  {
    key: "COUPON_NAME",
    text: "COUPON_NAME",
    description: "쿠폰 이름이 입려됩니다.",
  },
  {
    key: "DISCOUNT_INFO",
    text: "DISCOUNT_INFO",
    description: "쿠폰 할인정보가 입력됩니다. 예) 10%, 1,000원 할인",
  },
  {
    key: "USE_GUIDE",
    text: "USE_GUIDE",
    description: "'*** 매장에서 사용' 으로 입력됩니다.",
  },
  {
    key: "landing_url_button",
    text: "landing_url_button",
    description: "쿠폰정보를 확인할 수 있는 웹링크가 입력됩니다.",
  },
];

export const AUTO_CAMPAIGN_ALIMTALK_TEMPLATES_BY_CONDITION = {
  expiredPoint: [
    {
      key: "expiredPoint",
      title: null,
      message:
        "[적립금 소멸 안내]\n\n#{NAME}님, 보유하고 계신 적립금이 소멸될 예정입니다.\n\n기한 내 미사용시 해당 적립금은 자동 소멸되오니 이용에 참고 부탁드립니다.\n\n- 현재 보유 적립금 : #{POINT}P\n- 소멸 예정 적립금 : #{EXPIRED_POINT}P\n- 소멸 후 예상 잔여 적립금 : #{TOTAL_POINT}P\n- 사용방법: #{USE_GUIDE}\n- 유효기간 : #{EXPIRY_DATE}",
      notice:
        "이 메시지는 그로잉세일즈 이용약관에 따라 고객님의 매장결제를 통해 지급된 적립금 만료 안내 메시지입니다.",
    },
  ],
  creditRecharge: [
    {
      key: "creditRecharge",
      title: null,
      message:
        "[선불금 충전 완료 안내]\n\n안녕하세요,\n요청하신 선불금 충전이 정상적으로 완료되었습니다.\n\n[충전 내역]\n- 충전 매장 : #{STORE_NAME}\n- 충전 일시 : #{CHARGE_DATE}\n- 충전 금액 : #{CHARGE_AMOUNT}원\n- 충전 후 잔액 : #{BALANCE}원\n\n문의하기 : #{STORE_NUMBER}",
      notice:
        "이 메시지는 그로잉세일즈 이용약관에 따라 고객님이 유료로 충전하신 선불금 관한 안내 메시지입니다.",
    },
  ],
  creditUse: [
    {
      key: "creditUse",
      title: null,
      message:
        "[선불금 사용 안내]\n\n#{STORE_NAME}에 방문해 주셔서 감사합니다.\n사용하신 선불금 결제 내역을 안내해 드립니다.\n\n[선불금 사용 내역]\n- 매장명 : #{STORE_NAME}\n- 사용 일시 : #{USE_DATE}\n- 사용 금액 : #{USE_AMOUNT}원\n- 사용 후 잔액 : #{BALANCE}원\n\n사용 내역에 이상이 있을 경우 아래 연락처로 문의 부탁드립니다.\n\n문의하기 : #{STORE_NUMBER}",
      notice:
        "이 메시지는 그로잉세일즈 이용약관에 따라 고객님이 유료로 충전하신 선불금 사용에 관한 안내 메시지입니다.",
    },
  ],
  expiredCoupon: [
    {
      key: "expiredCoupon",
      title: null,
      featureTitle: "#{COUPON_ID} 쿠폰 만료 안내",
      buttonTitle: "쿠폰 확인하기",
      buttonLink: "#{landing_url_button}",
      message:
        "안녕하세요!\n\n쿠폰함에 보관 중인 쿠폰 중, 곧 유효기간이 만료되는 쿠폰이 있어 안내해 드립니다. \n만료일 이후에는 자동 소멸되어 사용이 불가하오니 참고 부탁드립니다.\n\n[만료 예정 쿠폰]\n- 기간안내 : #{COUPON_DATE}\n- 쿠폰명 : #{COUPON_NAME}\n- 할인 세부정보 : #{DISCOUNT_INFO}\n- 사용방법: #{USE_GUIDE}",
      notice:
        "이 메시지는 그로잉세일즈의 이용약관에 따라 매장에서의 주문거래를 통해 지급된 쿠폰 안내 메시지입니다.",
      guide:
        "- 만표 쿠폰 캠페인의 경우, 발송하시려는 쿠폰의 유효기간을 1-7일이 정도만 남도록 설정해 주셔야 효과가 있습니다.\n- 카페24 온라인 쿠폰의 경우 해당 캠페인을 위해서만 사용하셔야 캠페인 리포트에 기여 결제금액이 정확히 수집됩니다.",
    },
  ],
};

export const COUPON_ADDABLE_ALIMTALK_KEYS = ["expiredCoupon"];

export const EDITABLE_PARAMS_ALIMTALK_KEYS = ["#{COUPON_ID}"];
